(function () {
  'use strict';
  /* quince.pdp.js build: 2026-07-23-initiate-checkout-fix */

  /* Normalize stale trust / shipping copy — never claim Express / 1–2 day delivery */
  function qNormalizeTrustCopy() {
    var canonical = 'Free shipping & easy returns for 365 days.';
    document.querySelectorAll('.q-home__hero-title, .q-announce__msg, .q-sticky-bar__trust').forEach(function (el) {
      var t = String(el.textContent || '').trim();
      var next = t;
      if (
        /30[- ]?day/i.test(next) ||
        /PayPal\s*guest/i.test(next) ||
        /Card via PayPal/i.test(next) ||
        /Cards\s*&\s*PayPal/i.test(next) ||
        /Shipping (shown )?at checkout/i.test(next) ||
        /US Express rates before pay/i.test(next) ||
        /Free US Express/i.test(next) ||
        /JOB-SITE/i.test(next)
      ) {
        next = canonical;
      }
      if (next !== t) el.textContent = next;
    });
    document.querySelectorAll('.q-pdp__perk-text, .q-cart__shipping-free, .u-pdp__delivery-head span, .u-pdp__service, .q-cart__promise').forEach(function (el) {
      var t = String(el.textContent || '').trim();
      var next = t;
      if (
        /rates shown before|shown before (you )?pay/i.test(next) ||
        /US Express/i.test(next) ||
        /72\s*h(our)?/i.test(next) ||
        /1\s*[-–]\s*2\s*day/i.test(next)
      ) {
        next = /cart__shipping|shipping-free/i.test(el.className || '')
          ? 'Free US shipping'
          : /delivery-head/i.test((el.parentElement && el.parentElement.className) || '')
            ? 'Free US shipping — arrives in 3–8 business days'
            : 'Free US shipping · Arrives in 3–8 business days';
      }
      if (/30[- ]?day/i.test(next) && /return/i.test(next)) {
        next = next.replace(/30([- ]?)day/gi, '365$1day').replace(/\b30 days\b/gi, '365 days');
      }
      if (next !== t) el.textContent = next;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', qNormalizeTrustCopy);
  } else {
    qNormalizeTrustCopy();
  }

  var META_PIXEL_ID = '1507146397852103';

  function qLoadMetaPixel() {
    if (typeof window.fbq !== 'function') {
      var n = (window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      });
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
    }
    if (window.__velmorMetaPixelId === META_PIXEL_ID) return;
    window.fbq('init', META_PIXEL_ID);
    window.__velmorMetaPixelId = META_PIXEL_ID;
  }

  function qTrackMetaViewContent(variant, productTitle) {
    if (!variant || !variant.id) return;
    /* One ViewContent per PDP load (liquid no longer fires VC). */
    var vcKey = 'vc-' + String(variant.id);
    if (window.__velmorVCFired === vcKey) return;
    window.__velmorVCFired = vcKey;
    qLoadMetaPixel();
    if (typeof fbq !== 'function') return;
    var eventId = qMetaEventId('vc', variant.id);
    fbq(
      'track',
      'ViewContent',
      {
        content_ids: [String(variant.id)],
        content_type: 'product',
        content_name: productTitle || '',
        value: qVariantPrice(variant),
        currency: qMetaCurrency()
      },
      { eventID: eventId }
    );
  }

  qLoadMetaPixel();

  function qMetaCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  function qSitewideDiscountPct() {
    var el = document.querySelector('[data-q-pdp]');
    if (!el) return 0;
    var pct = parseFloat(el.getAttribute('data-auto-discount-pct') || '0');
    return isFinite(pct) && pct > 0 ? pct : 0;
  }

  function qApplySitewideDiscount(cents) {
    var pct = qSitewideDiscountPct();
    var amount = Number(cents) || 0;
    if (!(pct > 0) || !(amount > 0)) return amount;
    /* Match Shopify automatic % discount allotment (floor, not round). */
    var discountAmount = Math.floor((amount * pct) / 100);
    return amount - discountAmount;
  }

  function qVariantPrice(variant) {
    if (!variant || variant.price == null) return 0;
    return qApplySitewideDiscount(variant.price) / 100;
  }

  function qMetaEventId(prefix, variantId) {
    return String(prefix) + '-' + String(variantId) + '-' + Date.now();
  }

  function qGetCookie(name) {
    var m = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : '';
  }

  /** Persist Meta cookies on cart so order note_attributes → CAPI fbp/fbc. */
  function qSyncMetaCartAttributes() {
    var attrs = {};
    var fbp = qGetCookie('_fbp');
    var fbc = qGetCookie('_fbc');
    if (fbp) attrs._fbp = fbp;
    if (fbc) attrs._fbc = fbc;
    if (!attrs._fbp && !attrs._fbc) return Promise.resolve(null);
    var update = qShopifyFetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {
      return null;
    });
    /* Never block checkout if /cart/update.js hangs (CF 429 / proxy). */
    return Promise.race([
      update,
      new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(null);
        }, 2000);
      })
    ]);
  }

  function qGoToShopifyCheckout(form) {
    /* Prefer native checkout POST (keeps cart + discount apps). Fallback: /checkout. */
    try {
      if (form && form.tagName === 'FORM') {
        var existing = form.querySelector('input[data-q-checkout-flag]');
        if (!existing) {
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'checkout';
          hidden.value = '1';
          hidden.setAttribute('data-q-checkout-flag', '1');
          form.appendChild(hidden);
        }
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
    } catch (err) {
      /* fall through */
    }
    window.location.href = '/checkout';
  }

  /* Buy Now: checkout current item only, then restore prior cart on return. */
  var Q_BUY_NOW_CART_KEY = 'q_buy_now_cart_v1';

  function qIsCheckoutPath() {
    var p = window.location.pathname || '';
    return p.indexOf('/checkout') === 0 || p.indexOf('/checkouts') === 0;
  }

  function qCartJsonHeaders() {
    return { 'Content-Type': 'application/json', Accept: 'application/json' };
  }

  function qCartLinesForAdd(cart) {
    var items = (cart && cart.items) || [];
    return items
      .map(function (item) {
        var line = {
          id: item.variant_id || item.id,
          quantity: item.quantity || 1
        };
        if (item.properties && typeof item.properties === 'object') {
          var keys = Object.keys(item.properties);
          if (keys.length) line.properties = item.properties;
        }
        var plan =
          item.selling_plan_allocation &&
          item.selling_plan_allocation.selling_plan &&
          item.selling_plan_allocation.selling_plan.id;
        if (plan) line.selling_plan = plan;
        return line;
      })
      .filter(function (line) {
        return !!line.id;
      });
  }

  function qUpdateHeaderCartCount(count) {
    document.querySelectorAll('.q-header__cart-count, .q-drawer__cart-count').forEach(function (el) {
      if (count > 0) {
        el.textContent = String(count);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  function qSaveBuyNowCartSnapshot(cart) {
    try {
      sessionStorage.setItem(Q_BUY_NOW_CART_KEY, JSON.stringify(qCartLinesForAdd(cart)));
    } catch (err) {
      /* private mode / quota */
    }
  }

  function qRestoreBuyNowCartIfNeeded() {
    if (qIsCheckoutPath()) return;
    var raw;
    try {
      raw = sessionStorage.getItem(Q_BUY_NOW_CART_KEY);
    } catch (err) {
      return;
    }
    if (!raw) return;
    var lines;
    try {
      lines = JSON.parse(raw);
    } catch (err) {
      try {
        sessionStorage.removeItem(Q_BUY_NOW_CART_KEY);
      } catch (e2) {
        /* ignore */
      }
      return;
    }
    try {
      sessionStorage.removeItem(Q_BUY_NOW_CART_KEY);
    } catch (err) {
      /* ignore */
    }
    if (!Array.isArray(lines) || !lines.length) return;

    var headers = qCartJsonHeaders();
    qShopifyFetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers
    })
      .then(function (res) {
        if (!res.ok) throw new Error('clear failed');
        return qShopifyFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: headers,
          body: JSON.stringify({ items: lines })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('restore failed');
        return res.json();
      })
      .then(function (cart) {
        qUpdateHeaderCartCount((cart && cart.item_count) || 0);
        var path = window.location.pathname || '';
        if (path === '/cart' || path.indexOf('/cart/') === 0) {
          window.location.reload();
        }
      })
      .catch(function () {
        try {
          sessionStorage.setItem(Q_BUY_NOW_CART_KEY, raw);
        } catch (err) {
          /* ignore */
        }
      });
  }

  function qBuyNowCheckoutOnly(variantId, qty, variant, productTitle) {
    var headers = qCartJsonHeaders();
    return qShopifyFetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      })
      .then(function (cart) {
        qSaveBuyNowCartSnapshot(cart);
        return qShopifyFetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: headers
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('clear failed');
        return qShopifyFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: headers,
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        qTrackMetaAddToCart(variant, productTitle, qty);
        /* Buy Now skips /cart form — must fire IC here (CE may also fire; eventID differs). */
        qTrackMetaInitiateCheckout(variant, productTitle, qty);
        return qSyncMetaCartAttributes();
      })
      .then(function () {
        window.location.href = '/checkout';
      });
  }

  qRestoreBuyNowCartIfNeeded();
  window.addEventListener('pageshow', function () {
    qRestoreBuyNowCartIfNeeded();
  });

  function qTrackMetaAddToCart(variant, productTitle, quantity) {
    if (!variant || !variant.id) return;
    try {
      qLoadMetaPixel();
      var eventId = qMetaEventId('atc', variant.id);
      var payload = {
        content_ids: [String(variant.id)],
        content_type: 'product',
        contents: [{ id: String(variant.id), quantity: quantity || 1 }],
        value: qVariantPrice(variant) * (quantity || 1),
        currency: qMetaCurrency()
      };
      if (productTitle) payload.content_name = productTitle;
      /* Theme owns ATC (Ajax cart). Do not analytics.publish — CE would double-fire. */
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', payload, { eventID: eventId });
      }
    } catch (err) {
      /* Tracking must never block add-to-cart / checkout */
    }
  }

  function qTrackMetaInitiateCheckout(variant, productTitle, quantity) {
    /* Buy Now / single-SKU fallback. Cart uses qTrackMetaInitiateCheckoutFromDom. */
    if (!variant || !variant.id) return;
    try {
      qLoadMetaPixel();
      var qty = quantity || 1;
      var eventId = qMetaEventId('ic', variant.id);
      var payload = {
        content_ids: [String(variant.id)],
        content_type: 'product',
        contents: [{ id: String(variant.id), quantity: qty }],
        value: qVariantPrice(variant) * qty,
        currency: qMetaCurrency(),
        num_items: qty
      };
      if (productTitle) payload.content_name = productTitle;
      if (typeof fbq === 'function') {
        fbq('track', 'InitiateCheckout', payload, { eventID: eventId });
      }
    } catch (err) {
      /* Tracking must never block checkout */
    }
  }

  /** Fire IC for every line on the cart page (full contents + value). */
  function qTrackMetaInitiateCheckoutFromDom(cartRoot) {
    if (!cartRoot) return;
    try {
      qLoadMetaPixel();
      var ids = [];
      var contents = [];
      var value = 0;
      var numItems = 0;
      var firstTitle = '';
      cartRoot.querySelectorAll('.q-cart__item[data-variant-id]').forEach(function (line) {
        var vid = String(line.getAttribute('data-variant-id') || '').trim();
        if (!vid) return;
        var qtyWrap = line.querySelector('[data-q-cart-qty]');
        var qtyEl = line.querySelector('[data-q-cart-qty-value]');
        var qty =
          parseInt(
            (qtyWrap && qtyWrap.getAttribute('data-qty')) ||
              (qtyEl && qtyEl.textContent) ||
              '1',
            10
          ) || 1;
        var unitCents = parseInt(line.getAttribute('data-unit-cents') || '0', 10);
        if (!(unitCents > 0)) {
          var priceText = line.getAttribute('data-product-price') || '';
          unitCents = Math.round(parseFloat(String(priceText).replace(/[^0-9.]/g, '')) * 100) || 0;
        }
        var unit = unitCents / 100;
        ids.push(vid);
        contents.push({ id: vid, quantity: qty, item_price: unit });
        value += unit * qty;
        numItems += qty;
        if (!firstTitle) firstTitle = line.getAttribute('data-product-title') || '';
      });
      if (!ids.length) return;
      var eventId = qMetaEventId('ic', ids[0]);
      var payload = {
        content_ids: ids,
        content_type: 'product',
        contents: contents,
        value: Math.round(value * 100) / 100,
        currency: qMetaCurrency(),
        num_items: numItems
      };
      if (firstTitle) payload.content_name = firstTitle;
      if (typeof fbq === 'function') {
        fbq('track', 'InitiateCheckout', payload, { eventID: eventId });
      }
    } catch (err) {
      /* ignore */
    }
  }

  function qSleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function qShouldRetryShopifyStatus(status) {
    /* Do not retry 429 — retries make Cloudflare rate-limits worse. */
    return status === 503 || status === 502 || status === 504;
  }

  function qShopifyFetch(url, options, retriesLeft) {
    /* quince-cart-retry.js already retries /cart/* — avoid nested storms. */
    var remaining =
      retriesLeft == null
        ? window.__qCartFetchPatch && String(url).indexOf('/cart/') !== -1
          ? 0
          : 1
        : retriesLeft;
    return fetch(url, options)
      .then(function (res) {
        if (qShouldRetryShopifyStatus(res.status) && remaining > 0) {
          return qSleep(1200).then(function () {
            return qShopifyFetch(url, options, remaining - 1);
          });
        }
        return res;
      })
      .catch(function (err) {
        if (remaining > 0) {
          return qSleep(1200).then(function () {
            return qShopifyFetch(url, options, remaining - 1);
          });
        }
        throw err;
      });
  }

  /* Announcement rotate */
  var announce = document.querySelector('[data-q-announce]');
  if (announce) {
    var msgs = announce.querySelectorAll('[data-q-announce-msg]');
    var idx = 0;
    function showMsg(i) {
      msgs.forEach(function (m, j) {
        m.classList.toggle('is-active', j === i);
      });
    }
    if (msgs.length > 1) {
      setInterval(function () {
        idx = (idx + 1) % msgs.length;
        showMsg(idx);
      }, 5000);
    }
  }

  /* Menu drawer */
  function bindDrawer(openSel, drawerSel, closeSel, opts) {
    opts = opts || {};
    var openBtn = document.querySelector(openSel);
    var drawer = document.querySelector(drawerSel);
    if (!openBtn || !drawer) return;

    function openDrawer() {
      drawer.hidden = false;
      if (opts.bodyClass) document.body.classList.add(opts.bodyClass);
    }

    function closeDrawer() {
      drawer.hidden = true;
      if (opts.bodyClass) document.body.classList.remove(opts.bodyClass);
    }

    openBtn.addEventListener('click', openDrawer);
    drawer.querySelectorAll(closeSel).forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    if (opts.onOpen) opts.onOpen(openDrawer, closeDrawer);
  }

  bindDrawer('[data-q-menu-open]', '[data-q-drawer]', '[data-q-drawer-close]', {
    bodyClass: 'q-drawer-open',
    onOpen: function (openDrawer, closeDrawer) {
      var searchFromDrawer = document.querySelector('[data-q-drawer-search-open]');
      var searchOpen = document.querySelector('[data-q-search-open]');
      if (searchFromDrawer && searchOpen) {
        searchFromDrawer.addEventListener('click', function () {
          closeDrawer();
          searchOpen.click();
        });
      }
    }
  });
  bindDrawer('[data-q-search-open]', '[data-q-search]', '[data-q-search-close]', {
    bodyClass: 'q-search-open',
    onOpen: function () {
      var input = document.querySelector('[data-q-search] input[type="search"]');
      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 50);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var search = document.querySelector('[data-q-search]');
    if (search && !search.hidden) {
      search.hidden = true;
      document.body.classList.remove('q-search-open');
    }
  });
  bindDrawer('[data-q-filter-open]', '[data-q-filter-drawer]', '[data-q-filter-close]');

  /* Inline filter dropdowns — fixed positioning avoids scroll/overflow clipping */
  (function initFilterDropdowns() {
    var filterRoot = document.querySelector('[data-q-filters]');
    if (!filterRoot) return;

    var triggers = filterRoot.querySelectorAll('[data-q-filter-dropdown-trigger]');
    var panels = filterRoot.querySelectorAll('[data-q-filter-dropdown-panel]');
    if (!triggers.length || !panels.length) return;

    panels.forEach(function (panel) {
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });

    function closeAllFilterDropdowns() {
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = true;
      });
    }

    function positionPanel(trigger, panel) {
      var rect = trigger.getBoundingClientRect();
      var isPrice = panel.hasAttribute('data-q-filter-panel-price');
      var panelWidth = isPrice ? 260 : Math.max(rect.width, 160);
      var left = rect.left;
      var maxLeft = window.innerWidth - panelWidth - 12;
      if (left > maxLeft) left = maxLeft;
      if (left < 12) left = 12;
      panel.style.top = rect.bottom + 4 + 'px';
      panel.style.left = left + 'px';
      panel.style.minWidth = panelWidth + 'px';
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var panel = panels[index];
        if (!panel) return;
        var willOpen = panel.hidden;
        closeAllFilterDropdowns();
        if (willOpen) {
          panel.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          positionPanel(trigger, panel);
        }
      });
    });

    document.addEventListener('click', closeAllFilterDropdowns);
    window.addEventListener('resize', closeAllFilterDropdowns);
    window.addEventListener('scroll', closeAllFilterDropdowns, { passive: true });
  })();

  /* Price range filter — min/max inputs */
  (function initPriceFilters() {
    function parsePrice(value) {
      if (!value) return null;
      var num = parseFloat(String(value).replace(/,/g, ''));
      return isNaN(num) ? null : num;
    }

    function clampPriceInputs(form) {
      var minInput = form.querySelector('[data-q-price-min]');
      var maxInput = form.querySelector('[data-q-price-max]');
      if (!minInput || !maxInput) return;

      var minBound = parsePrice(minInput.getAttribute('data-min'));
      if (minBound === null) minBound = 0;
      var maxBound = parsePrice(maxInput.getAttribute('data-max'));
      var minVal = parsePrice(minInput.value);
      var maxVal = parsePrice(maxInput.value);

      if (minVal !== null) {
        if (minVal < minBound) minInput.value = String(minBound);
        if (maxBound !== null && minVal > maxBound) minInput.value = String(maxBound);
      }
      if (maxVal !== null) {
        if (maxBound !== null && maxVal > maxBound) maxInput.value = String(maxBound);
        if (minVal !== null && maxVal < minVal) maxInput.value = minInput.value;
      }
    }

    document.querySelectorAll('[data-q-price-filter]').forEach(function (form) {
      form.querySelectorAll('[data-q-price-min], [data-q-price-max]').forEach(function (input) {
        input.addEventListener('change', function () {
          clampPriceInputs(form);
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        clampPriceInputs(form);
        var url = new URL(window.location.href);
        var minInput = form.querySelector('[data-q-price-min]');
        var maxInput = form.querySelector('[data-q-price-max]');

        if (minInput) {
          url.searchParams.delete(minInput.name);
          if (minInput.value.trim()) {
            url.searchParams.set(minInput.name, minInput.value.trim());
          }
        }
        if (maxInput) {
          url.searchParams.delete(maxInput.name);
          if (maxInput.value.trim()) {
            url.searchParams.set(maxInput.name, maxInput.value.trim());
          }
        }

        window.location.href = url.toString();
      });
    });
  })();

  /* Sort redirect */
  var sortSelect = document.querySelector('[data-q-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* PDP variant + sticky */
  var pdp = document.querySelector('[data-q-pdp]');
  if (pdp) {
    var jsonEl = document.querySelector('[data-q-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = document.getElementById('q-product-form');
    var variantInput = form && form.querySelector('[data-q-variant-id]');
    if (product && product.variants && product.variants.length) {
      var initialVariant = product.variants.find(function (v) {
        return variantInput && String(v.id) === String(variantInput.value);
      }) || product.variants[0];
      qTrackMetaViewContent(initialVariant, product.title);
    }
    var atcInline = form && form.querySelector('[data-q-atc]');
    var buyNowInline = form && form.querySelector('[data-q-buy-now]');
    var actionsEl = form && form.querySelector('.q-pdp__actions');
    var stickyTarget = actionsEl || atcInline;
    var stickyBar = document.querySelector('[data-q-sticky]');
    var stickyBtn = document.querySelector('[data-q-sticky-add]');
    var stickyBuy = document.querySelector('[data-q-sticky-buy]');
    var stickyAtcBtn = document.querySelector('[data-u-sticky-atc]');
    var priceEl = document.querySelector('[data-q-price]');
    var compareEl = document.querySelector('[data-q-compare]');
    var saveEl = document.querySelector('[data-q-save]');
    var compareCol = document.querySelector('[data-q-price-compare-col]');
    var stickyPrice = document.querySelector('[data-q-sticky-price]');
    var stickySave = document.querySelector('[data-q-sticky-save]');
    var installmentEl = document.querySelector('[data-q-installment]');
    var offPctEl = document.querySelector('[data-q-off-pct]');
    var mobileStickyMq = window.matchMedia('(max-width: 749px)');
    var isUnicePdp = pdp.classList.contains('u-pdp');
    var addToBagLabel = isUnicePdp ? 'Add to bag' : 'ADD TO BAG';
    var buyNowLabel = isUnicePdp ? 'Buy Now' : 'BUY NOW';
    var buyNowInlineLabel = isUnicePdp ? 'Buy Now' : 'Or checkout now';
    var soldOutLabel = isUnicePdp ? 'Sold out' : 'SOLD OUT';
    var checkoutBusy = false;

    function hasUrlVariantParam() {
      try {
        return new URLSearchParams(window.location.search).has('variant');
      } catch (err) {
        return window.location.search.indexOf('variant=') >= 0;
      }
    }

    function qColorTokensFromText(text) {
      var s = String(text || '').toLowerCase();
      var tokens = [];
      var dictionary = [
        'ginger',
        'orange',
        'auburn',
        'highlight',
        'blonde',
        'blond',
        'burgundy',
        'wine',
        'red',
        'brown',
        'chocolate',
        'black',
        'natural black',
        'natural',
        'grey',
        'gray',
        'pink',
        'purple',
        'blue',
        'green',
        'ombre',
        'balayage',
        '613',
        '99j',
        'f4/27',
        '#1',
        '#4',
        '#27'
      ];
      dictionary.forEach(function (token) {
        if (s.indexOf(token) >= 0) tokens.push(token);
      });
      return tokens;
    }

    function qVariantColorBlob(variant) {
      var parts = ((variant && variant.options) || []).slice();
      parts.push((variant && variant.title) || '');
      return parts.join(' ').toLowerCase();
    }

    function qExpandColorTokens(tokens, title) {
      var out = (tokens || []).slice();
      var s = String(title || '').toLowerCase();
      /* Title colors often don't appear verbatim on option labels (e.g. Ginger → Highlight F4/27). */
      if (/ginger|orange|auburn|copper|highlight|f4\/27/.test(s)) {
        ['highlight', 'f4/27', 'ginger', 'orange', 'auburn', 'copper'].forEach(function (t) {
          if (out.indexOf(t) < 0) out.push(t);
        });
      }
      if (/burgundy|wine|99j/.test(s)) {
        ['burgundy', 'wine', '99j', 'red'].forEach(function (t) {
          if (out.indexOf(t) < 0) out.push(t);
        });
      }
      return out;
    }

    function qVariantMatchesColorTokens(variant, tokens) {
      if (!tokens || !tokens.length) return false;
      var blob = qVariantColorBlob(variant);
      for (var i = 0; i < tokens.length; i++) {
        if (blob.indexOf(tokens[i]) >= 0) return true;
      }
      return false;
    }

    function qVariantLooksNaturalBlack(variant) {
      var blob = qVariantColorBlob(variant);
      return /natural black|#1\b|jet black|1b\b/.test(blob) && !/highlight|ginger|orange|blonde|burgundy/.test(blob);
    }

    function qVariantFeaturedImageId(variant) {
      if (!variant) return '';
      if (variant.featured_image && variant.featured_image.id != null) {
        return String(variant.featured_image.id);
      }
      if (variant.featured_media && variant.featured_media.id != null) {
        return String(variant.featured_media.id);
      }
      if (variant.image_id != null) return String(variant.image_id);
      return '';
    }

    function selectDefaultAvailableVariant() {
      /*
       * Prefer variant whose image matches the PDP hero, then title color keywords,
       * then cheapest (shorter length on ties). Avoids "Ginger Orange" hero + Natural Black default.
       */
      if (!product || !product.variants || !product.variants.length) return;
      if (hasUrlVariantParam()) return;

      var featuredId = '';
      if (product.featured_image && product.featured_image.id != null) {
        featuredId = String(product.featured_image.id);
      } else if (product.featured_media && product.featured_media.id != null) {
        featuredId = String(product.featured_media.id);
      }

      var titleTokens = qExpandColorTokens(qColorTokensFromText(product.title || ''), product.title || '');
      var titleWantsColor =
        titleTokens.length > 0 &&
        !/natural black only/.test(String(product.title || '').toLowerCase()) &&
        (/ginger|orange|auburn|copper|highlight|blonde|burgundy|wine|chocolate|brown|99j|613|f4\/27/.test(
          String(product.title || '').toLowerCase()
        ) ||
          titleTokens.some(function (t) {
            return t !== 'black' && t !== 'natural' && t !== 'natural black';
          }));
      var available = product.variants.filter(function (v) {
        return !!v.available;
      });
      if (!available.length) return;

      var picked = null;
      if (featuredId) {
        for (var i = 0; i < available.length; i++) {
          if (qVariantFeaturedImageId(available[i]) === featuredId) {
            picked = available[i];
            break;
          }
        }
      }
      if (!picked && titleTokens.length) {
        for (var j = 0; j < available.length; j++) {
          if (qVariantMatchesColorTokens(available[j], titleTokens)) {
            picked = available[j];
            break;
          }
        }
      }
      if (!picked && titleWantsColor) {
        for (var k = 0; k < available.length; k++) {
          if (!qVariantLooksNaturalBlack(available[k])) {
            picked = available[k];
            break;
          }
        }
      }
      if (!picked) {
        available.forEach(function (v) {
          var price = Number(v.price) || 0;
          if (!picked) {
            picked = v;
            return;
          }
          var cur = Number(picked.price) || 0;
          if (price < cur) {
            picked = v;
            return;
          }
          if (price === cur && qVariantLengthInches(v) < qVariantLengthInches(picked)) {
            picked = v;
          }
        });
      }

      if (!picked || !picked.options) return;
      picked.options.forEach(function (optVal, i) {
        var key = product.options[i];
        if (!key) return;
        pdp.querySelectorAll('[data-q-option-input]').forEach(function (input) {
          var name = input.name.replace('options[', '').replace(']', '');
          if (name === key) input.checked = input.value === optVal;
        });
      });
    }

    function selectCheapestAvailableVariant() {
      selectDefaultAvailableVariant();
    }

    function qVariantLengthInches(variant) {
      try {
        var opts = (variant && variant.options) || [];
        for (var i = 0; i < opts.length; i++) {
          var m = String(opts[i] || '').match(/(\d+)\s*(?:inches?|")/i);
          if (m) return parseInt(m[1], 10) || 999;
        }
        var title = String((variant && variant.title) || '');
        var m2 = title.match(/(\d+)\s*(?:inches?|")/i);
        return m2 ? parseInt(m2[1], 10) || 999 : 999;
      } catch (err) {
        return 999;
      }
    }

    function ensureUniceInlineCheckout() {
      if (!isUnicePdp || !buyNowInline) return;
      buyNowInline.hidden = false;
      buyNowInline.removeAttribute('hidden');
    }

    function redirectAfterAddPath() {
      /* Add to bag → cart; Buy Now handles /checkout separately. */
      return '/cart';
    }

    function redirectAfterAdd() {
      window.setTimeout(function () {
        window.location.href = redirectAfterAddPath();
      }, 200);
    }

    function isInlineActionsVisible() {
      /* True when BUY NOW / ADD TO BAG under variants is usable in the viewport. */
      var el = stickyTarget || atcInline || buyNowInline;
      if (!el) return false;
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var stickyReserve = 96;
      if (stickyBar && !stickyBar.classList.contains('is-suppressed')) {
        stickyReserve = Math.max(stickyBar.offsetHeight || 0, 96);
      }
      var headerReserve = 56;
      var visibleTop = Math.max(rect.top, headerReserve);
      var visibleBottom = Math.min(rect.bottom, vh - stickyReserve);
      var visibleHeight = visibleBottom - visibleTop;
      if (visibleHeight <= 0) return false;
      var needed = Math.min(Math.max(rect.height, 44), 120);
      return visibleHeight >= needed;
    }

    function shouldShowStickyBar() {
      /*
       * Show bottom bar whenever inline CTA is obscured — on first paint (long
       * variant grids), scrolling down, or scrolling up past the CTA.
       * Hide only when the under-spec BUY NOW / ADD TO BAG is clearly visible.
       */
      return !isInlineActionsVisible();
    }

    function setStickyVisible(show) {
      if (!stickyBar || !mobileStickyMq.matches) return;
      stickyBar.hidden = false;
      stickyBar.classList.toggle('is-suppressed', !show);
      /* Keep suppressed bar out of hit-testing (some WebViews ignore translate-only hide) */
      if (show) {
        stickyBar.removeAttribute('inert');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.setAttribute('inert', '');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.toggle('q-has-sticky', show);
    }

    function syncStickyVisibility() {
      if (!stickyBar) return;
      if (!mobileStickyMq.matches) {
        stickyBar.classList.add('is-suppressed');
        stickyBar.setAttribute('inert', '');
        stickyBar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('q-has-sticky');
        return;
      }
      stickyBar.hidden = false;
      setStickyVisible(shouldShowStickyBar());
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function splitTrueCost(sale) {
      var total = Math.floor((sale * 80) / 100);
      var materials = Math.floor((total * 513) / 1000);
      var crafting = Math.floor((total * 290) / 1000);
      var packaging = Math.floor((total * 5) / 1000);
      var freight = Math.floor((total * 51) / 1000);
      var fees = Math.floor((total * 47) / 1000);
      var duties = total - materials - crafting - packaging - freight - fees;
      if (duties < 0) duties = 0;
      return {
        total: total,
        materials: materials,
        crafting: crafting,
        duties: duties,
        freight: freight,
        fees: fees + packaging
      };
    }

    function setText(selector, text) {
      var el = document.querySelector(selector);
      if (el) el.textContent = text;
    }

    /* Keep the cost breakdown on the same selling price and strike as the price block. */
    function updatePriceStory(sale, strike) {
      var retail = strike > sale ? strike : sale;
      var hasRetail = retail > sale;
      var pct = hasRetail ? Math.round(((retail - sale) / retail) * 100) : 0;
      var cost = splitTrueCost(sale);
      setText('[data-q-trans-sale]', formatMoney(sale));
      var saveEl = document.querySelector('[data-q-trans-save]');
      if (saveEl) {
        saveEl.hidden = !hasRetail;
        if (saveEl) {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }
      var retailCol = document.querySelector('[data-q-trans-retail-col]');
      if (retailCol) retailCol.hidden = !hasRetail;
      setText('[data-q-trans-retail]', formatMoney(retail));
      setText('[data-q-trans-markup]', '+' + formatMoney(retail - sale) + ' markup');
      setText('[data-q-trans-materials]', formatMoney(cost.materials));
      setText('[data-q-trans-crafting]', formatMoney(cost.crafting));
      setText('[data-q-trans-duties]', formatMoney(cost.duties));
      setText('[data-q-trans-freight]', formatMoney(cost.freight));
      setText('[data-q-trans-fees]', formatMoney(cost.fees));
      setText('[data-q-trans-total]', formatMoney(cost.total));
      var bar = document.querySelector('[data-q-trans-bar]');
      if (bar) bar.setAttribute('aria-label', 'Cost breakdown of ' + formatMoney(cost.total));
      setText('[data-q-compare-sale]', formatMoney(sale));
      setText('[data-q-compare-market]', formatMoney(retail));
      setText('[data-q-compare-dept]', formatMoney(retail));
      ['[data-q-compare-market-save]', '[data-q-compare-dept-save]'].forEach(function (selector) {
        var el = document.querySelector(selector);
        if (!el) return;
        el.hidden = !hasRetail;
        if (hasRetail) el.textContent = 'Save ' + pct + '%';
      });
    }

    function setActionButtons(variant) {
      var available = variant && variant.available;
      if (atcInline) {
        atcInline.textContent = available ? addToBagLabel : soldOutLabel;
        atcInline.disabled = !available || checkoutBusy;
      }
      if (buyNowInline) {
        buyNowInline.textContent = available ? buyNowInlineLabel : soldOutLabel;
        buyNowInline.disabled = !available || checkoutBusy;
      }
      if (stickyBtn) {
        stickyBtn.disabled = !available || checkoutBusy;
        /* Unice sticky buy is plain text; classic sticky keeps BUY NOW — $price markup */
        if (isUnicePdp && available && !checkoutBusy) {
          stickyBtn.textContent = buyNowLabel;
        }
      }
      if (stickyBuy) {
        stickyBuy.disabled = !available || checkoutBusy;
        if (available && !checkoutBusy) stickyBuy.textContent = buyNowLabel;
      }
      if (stickyAtcBtn) {
        stickyAtcBtn.disabled = !available || checkoutBusy;
        if (available && !checkoutBusy) stickyAtcBtn.textContent = addToBagLabel;
      }
    }

    function resolveVariant() {
      var variant = findVariant();
      if (variant) return variant;
      if (!variantInput || !product) return null;
      var id = parseInt(variantInput.value, 10);
      if (!id) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === id) return product.variants[i];
      }
      return { id: id, price: 0 };
    }

    function goToCheckout(trigger) {
      if (checkoutBusy || !variantInput) return;
      var variantId = parseInt(variantInput.value, 10);
      if (!variantId) return;
      if (trigger && trigger.disabled) return;

      var variant = resolveVariant();
      var productTitle = product && product.title;
      checkoutBusy = true;
      var buyButtons = [buyNowInline, isUnicePdp ? stickyBtn : stickyBuy].filter(Boolean);
      var prevStickyHtml = stickyBtn ? stickyBtn.innerHTML : '';
      var prevStickyBuyHtml = stickyBuy ? stickyBuy.innerHTML : '';
      var prevBuyNowLabel = buyNowInline ? buyNowInline.textContent : '';
      buyButtons.forEach(function (btn) {
        btn.disabled = true;
        btn.textContent = 'Processing…';
      });
      if (atcInline) atcInline.disabled = true;

      function restoreCheckoutButtons() {
        checkoutBusy = false;
        if (stickyBtn) stickyBtn.innerHTML = prevStickyHtml;
        if (stickyBuy) stickyBuy.innerHTML = prevStickyBuyHtml;
        if (buyNowInline) buyNowInline.textContent = prevBuyNowLabel || buyNowLabel;
        if (atcInline) atcInline.disabled = false;
        var current = findVariant();
        if (current) {
          setActionButtons(current);
        } else {
          buyButtons.forEach(function (btn) {
            btn.disabled = false;
          });
        }
      }

      /*
        Buy Now: snapshot cart → clear → add this variant only → /checkout.
        Prior cart is restored when the shopper returns to the storefront
        (see qRestoreBuyNowCartIfNeeded). Checkout total = this item only.
      */
      var qtyEl = form && form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      qBuyNowCheckoutOnly(variantId, qty, variant, productTitle).catch(function () {
        qRestoreBuyNowCartIfNeeded();
        restoreCheckoutButtons();
        alert('Unable to start checkout. Please try again.');
      });
    }

    function findVariant() {
      if (!product) return null;
      var selected = {};
      pdp.querySelectorAll('[data-q-option-input]:checked').forEach(function (input) {
        var name = input.name.replace('options[', '').replace(']', '');
        selected[name] = input.value;
      });
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          var key = product.options[i];
          return selected[key] === opt;
        });
      });
    }

    function retailOptionDisplay(raw) {
      var text = String(raw || '').replace(/\s+/g, ' ').trim();
      if (!text) return text;
      text = text.replace(/(\d+)\s*inches\b/gi, '$1"');
      text = text.replace(/\s*Lace Front Wig\s*/gi, ' ');
      text = text.replace(/\s*Lace Wig\s*/gi, ' ');
      return text.replace(/\s+/g, ' ').trim();
    }

    function updateOptionLegends() {
      pdp.querySelectorAll('.q-pdp__option').forEach(function (fieldset) {
        var checked = fieldset.querySelector('[data-q-option-input]:checked');
        var selectedEl = fieldset.querySelector('[data-q-option-selected]');
        if (checked && selectedEl) {
          var label = checked.id
            ? fieldset.querySelector('label[for="' + checked.id + '"]')
            : null;
          var display =
            (label && (label.getAttribute('data-u-option-display') || label.textContent)) ||
            retailOptionDisplay(checked.value);
          selectedEl.textContent = String(display || '').replace(/\s+/g, ' ').trim();
        }
      });
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      setActionButtons(variant);
      var listPrice = Number(variant.price) || 0;
      var checkoutPrice = qApplySitewideDiscount(listPrice);
      /* Main = discounted checkout price; strike = traditional-retail reference (same formula as Liquid). */
      var displayPrice = checkoutPrice;
      var retailPct = parseInt(pdp.getAttribute('data-retail-pct') || '0', 10) || 0;
      var strikePrice = 0;
      if (retailPct > 0 && displayPrice > 0) {
        var strikeRaw = Math.floor((displayPrice * 100) / (100 - retailPct));
        strikePrice = Math.round(strikeRaw / 100) * 100;
        if (strikePrice <= displayPrice) strikePrice = strikeRaw;
      } else {
        var compareAt = variant.compare_at_price ? Number(variant.compare_at_price) : 0;
        if (qSitewideDiscountPct() > 0 && listPrice > displayPrice) {
          strikePrice = listPrice;
        } else if (compareAt > displayPrice) {
          strikePrice = compareAt;
        }
      }
      var checkoutNoteEl = document.querySelector('[data-q-checkout-note]');
      var checkoutPriceEl = document.querySelector('[data-q-checkout-price]');
      if (checkoutPriceEl) checkoutPriceEl.textContent = formatMoney(checkoutPrice);
      if (checkoutNoteEl) checkoutNoteEl.hidden = true;
      if (stickyBtn && stickyPrice) stickyPrice.textContent = formatMoney(displayPrice);
      if (priceEl) priceEl.textContent = formatMoney(displayPrice);
      if (installmentEl) installmentEl.textContent = formatMoney(Math.round(checkoutPrice / 4));
      var hasCompare = strikePrice > displayPrice;
      if (compareCol) compareCol.hidden = !hasCompare;
      if (saveEl) saveEl.hidden = !hasCompare;
      if (compareEl && hasCompare) {
        compareEl.textContent = formatMoney(strikePrice);
      }
      if (hasCompare) {
        var pct = Math.round(((strikePrice - displayPrice) / strikePrice) * 100);
        var saveCents = strikePrice - displayPrice;
        var saveLabel = 'You save ' + pct + '%';
        if (saveEl) {
          saveEl.hidden = false;
          saveEl.removeAttribute('hidden');
          saveEl.textContent = saveLabel;
        }
        if (stickySave) {
          stickySave.hidden = false;
          stickySave.removeAttribute('hidden');
          stickySave.textContent = saveLabel;
        }
        if (offPctEl) {
          offPctEl.hidden = false;
          offPctEl.textContent = '-' + pct + '%';
        }
      } else {
        if (saveEl) {
          saveEl.hidden = true;
          saveEl.textContent = '';
        }
        if (stickySave) {
          stickySave.hidden = true;
          stickySave.textContent = '';
        }
        if (offPctEl) offPctEl.hidden = true;
      }
      var stickyCompare = document.querySelector('[data-q-sticky-compare]');
      if (stickyCompare) {
        if (hasCompare) {
          stickyCompare.hidden = false;
          stickyCompare.removeAttribute('hidden');
          stickyCompare.textContent = formatMoney(strikePrice);
        } else {
          stickyCompare.hidden = true;
        }
      }
      updatePriceRangeHint(variant);
      updatePriceStory(displayPrice, strikePrice);
    }

    function updatePriceRangeHint(variant) {
      var rangeEl = document.querySelector('[data-u-price-range]');
      if (!rangeEl) return;
      var minCents = Number(rangeEl.getAttribute('data-min-cents') || 0);
      var maxCents = Number(rangeEl.getAttribute('data-max-cents') || 0);
      if (!minCents || maxCents <= minCents) {
        rangeEl.hidden = true;
        return;
      }
      rangeEl.hidden = false;
      var hintEl = rangeEl.querySelector('[data-u-price-range-hint]');
      var checkoutPrice = qApplySitewideDiscount(Number((variant && variant.price) || 0) || 0);
      if (hintEl) {
        if (checkoutPrice > minCents * 1.08) {
          hintEl.textContent = ' · longer length selected (from ' + formatMoney(minCents) + ')';
        } else {
          hintEl.textContent = ' · longer lengths cost more';
        }
      }
    }

    function bindOptionCollapse() {
      pdp.querySelectorAll('[data-u-option-collapse]').forEach(function (fieldset) {
        var btn = fieldset.querySelector('[data-u-option-more]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          fieldset.classList.remove('is-collapsed');
          fieldset.querySelectorAll('.u-pdp__option-label--extra').forEach(function (label) {
            label.hidden = false;
            label.removeAttribute('hidden');
          });
          btn.hidden = true;
        });
      });
    }

    pdp.querySelectorAll('[data-q-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateOptionLegends();
        updateVariant();
      });
    });

    /* Ensure PDP price matches checkout even if HTML was cached without discount. */
    ensureUniceInlineCheckout();
    selectCheapestAvailableVariant();
    bindOptionCollapse();
    updateVariant();
    updatePriceRangeHint(findVariant());

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (checkoutBusy) return;
        var variant = resolveVariant();
        if (!variant || !variant.available) return;

        checkoutBusy = true;
        if (atcInline) {
          atcInline.disabled = true;
          atcInline.textContent = isUnicePdp ? 'Adding…' : 'Adding…';
        }
        if (buyNowInline) buyNowInline.disabled = true;
        if (stickyAtcBtn) stickyAtcBtn.disabled = true;

        var qtyEl = form.querySelector('[name="quantity"]');
        var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
        if (!qty || qty < 1) qty = 1;

        qShopifyFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            qTrackMetaAddToCart(variant, product && product.title);
            return qSyncMetaCartAttributes();
          })
          .then(function () {
            redirectAfterAdd();
          })
          .catch(function () {
            checkoutBusy = false;
            if (atcInline) {
              atcInline.disabled = false;
              atcInline.textContent = addToBagLabel;
            }
            if (buyNowInline) buyNowInline.disabled = false;
            if (stickyAtcBtn) stickyAtcBtn.disabled = false;
            var current = findVariant();
            if (current) setActionButtons(current);
            alert('Unable to add to bag. Please try again.');
          });
      });
    }

    if (buyNowInline) {
      buyNowInline.addEventListener('click', function () {
        goToCheckout(buyNowInline);
      });
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (isUnicePdp) {
          goToCheckout(stickyBtn);
          return;
        }
        if (atcInline && !atcInline.disabled) atcInline.click();
      });
    }

    if (stickyBuy) {
      stickyBuy.addEventListener('click', function () {
        goToCheckout(stickyBuy);
      });
    }

    function syncExpressCheckoutVisibility() {
      var buy = form && form.querySelector('.q-pdp__buy');
      var express = form && form.querySelector('.q-pdp__express');
      var dyn = form && form.querySelector('.q-pdp__dynamic');
      if (!express || !dyn) return;

      var accel = dyn.querySelector('shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
      var brandedBtn = dyn.querySelector(
        '.shopify-payment-button__button:not(.shopify-payment-button__button--unbranded)'
      );
      var spb = dyn.querySelector('.shopify-payment-button');
      var hasWallet = false;
      var awaiting = !!(buy && buy.classList.contains('q-pdp__buy--await-express'));

      function looksPainted(el) {
        if (!el) return false;
        var r = el.getBoundingClientRect();
        /* During await express is opacity:0 but still has real half-width box */
        return r.height >= 24 && r.width >= 40;
      }

      if (looksPainted(brandedBtn) || looksPainted(accel)) {
        hasWallet = true;
      } else if (spb) {
        /* GPay / Shop Pay often paints as a filled payment-button shell */
        var buttons = spb.querySelectorAll('button, [role="button"], iframe');
        for (var i = 0; i < buttons.length; i++) {
          if (looksPainted(buttons[i])) {
            hasWallet = true;
            break;
          }
        }
        if (!hasWallet && looksPainted(spb) && spb.innerHTML && spb.innerHTML.length > 20) {
          hasWallet = true;
        }
      }

      if (hasWallet) {
        express.classList.remove('is-empty');
        if (buy) {
          buy.classList.add('has-express');
          buy.classList.remove('q-pdp__buy--await-express');
        }
        return;
      }

      if (awaiting && (accel || spb || brandedBtn)) {
        express.classList.remove('is-empty');
        if (buy) buy.classList.remove('has-express');
        return;
      }

      express.classList.add('is-empty');
      if (buy) buy.classList.remove('has-express');
    }

    var expressSettleTries = 0;
    function settleExpressCheckout() {
      syncExpressCheckoutVisibility();
      var buy = form && form.querySelector('.q-pdp__buy');
      if (!buy) return;
      if (buy.classList.contains('has-express')) {
        buy.classList.remove('q-pdp__buy--await-express');
        return;
      }
      expressSettleTries += 1;
      /* ~8s for Shopify wallets; then collapse to full-width ATC + Or checkout now */
      if (expressSettleTries >= 8) {
        buy.classList.remove('q-pdp__buy--await-express');
        var express = form.querySelector('.q-pdp__express');
        if (express) express.classList.add('is-empty');
        buy.classList.remove('has-express');
      }
    }

    settleExpressCheckout();
    window.addEventListener('load', settleExpressCheckout);
    [200, 600, 1200, 2000, 3000, 4500, 6000, 8000].forEach(function (ms) {
      window.setTimeout(settleExpressCheckout, ms);
    });
    if (window.MutationObserver && form) {
      var expressRoot = form.querySelector('.q-pdp__dynamic');
      if (expressRoot) {
        new MutationObserver(function () {
          syncExpressCheckoutVisibility();
        }).observe(expressRoot, { childList: true, subtree: true, attributes: true });
      }
    }

    if (stickyBar) {
      stickyBar.hidden = false;
      syncStickyVisibility();
      if (stickyTarget) {
        var atcObserver = new IntersectionObserver(
          function () {
            syncStickyVisibility();
          },
          { threshold: [0, 0.01, 0.25, 0.5, 1], rootMargin: '0px 0px -104px 0px' }
        );
        atcObserver.observe(stickyTarget);
      }
      window.addEventListener('scroll', syncStickyVisibility, { passive: true });
      window.addEventListener('resize', syncStickyVisibility);
      window.addEventListener('orientationchange', syncStickyVisibility);
      window.addEventListener('load', syncStickyVisibility);
      requestAnimationFrame(syncStickyVisibility);
    }

    mobileStickyMq.addEventListener('change', function () {
      syncStickyVisibility();
    });

    /* PDP gallery — Thumb + Stage (desktop) / swipe + counter (mobile) */
    var gallery = pdp.querySelector('[data-q-gallery]');
    if (gallery) {
      var track = gallery.querySelector('[data-q-gallery-track]');
      var realSlides = gallery.querySelectorAll('[data-q-slide]');
      var thumbs = gallery.querySelectorAll('[data-q-gallery-thumb]');
      var counterEl = gallery.querySelector('[data-q-gallery-counter]');
      var prevBtn = gallery.querySelector('[data-q-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-q-gallery-next]');
      var progressEl = gallery.querySelector('[data-q-gallery-progress]');
      var scrollTicking = false;
      var looping = false;
      var totalSlides = realSlides.length;
      var allSlides = realSlides;
      var hasInfiniteClones = false;
      var activeIndex = 0;
      var galleryDesktopMq = window.matchMedia('(min-width: 750px)');

      function isDesktopGallery() {
        return galleryDesktopMq.matches;
      }

      function teardownInfiniteLoop() {
        if (!hasInfiniteClones || !track) return;
        track.querySelectorAll('[data-q-slide-clone]').forEach(function (el) {
          el.remove();
        });
        allSlides = realSlides;
        hasInfiniteClones = false;
      }

      function updateCounter(index) {
        if (!counterEl || totalSlides < 1) return;
        var safeIndex = ((index % totalSlides) + totalSlides) % totalSlides;
        counterEl.textContent = (safeIndex + 1) + '/' + totalSlides;
        if (progressEl) progressEl.style.transform = 'translateX(' + safeIndex * 100 + '%)';
      }

      function setActiveIndex(index) {
        var safeIndex = ((index % totalSlides) + totalSlides) % totalSlides;
        activeIndex = safeIndex;
        thumbs.forEach(function (thumb, i) {
          var active = i === safeIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        updateCounter(safeIndex);
        gallery.querySelectorAll('[data-q-gallery-dot]').forEach(function (dot, i) {
          var active = i === safeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (prevBtn) prevBtn.disabled = totalSlides < 2;
        if (nextBtn) nextBtn.disabled = totalSlides < 2;

        /* Scroll only the thumbs rail — never use scrollIntoView (jumps page to top on mobile resize). */
        var activeThumb = thumbs[safeIndex];
        var thumbsRail = activeThumb && activeThumb.parentElement;
        if (activeThumb && thumbsRail) {
          if (isDesktopGallery()) {
            var railTop =
              activeThumb.offsetTop - (thumbsRail.clientHeight - activeThumb.offsetHeight) / 2;
            if (typeof thumbsRail.scrollTo === 'function') {
              thumbsRail.scrollTo({ top: Math.max(0, railTop), behavior: 'smooth' });
            } else {
              thumbsRail.scrollTop = Math.max(0, railTop);
            }
          } else {
            var railLeft =
              activeThumb.offsetLeft - (thumbsRail.clientWidth - activeThumb.offsetWidth) / 2;
            if (typeof thumbsRail.scrollTo === 'function') {
              thumbsRail.scrollTo({ left: Math.max(0, railLeft), behavior: 'smooth' });
            } else {
              thumbsRail.scrollLeft = Math.max(0, railLeft);
            }
          }
        }
      }

      function getTrackSlideWidth() {
        return track ? track.clientWidth : 0;
      }

      function getSlideScrollLeft(index) {
        if (!track || !allSlides[index]) return 0;
        return allSlides[index].offsetLeft;
      }

      function getScrollIndex() {
        if (!track || !allSlides.length) return 0;
        var viewMid = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < allSlides.length; i++) {
          var slide = allSlides[i];
          var mid = slide.offsetLeft + slide.offsetWidth / 2;
          var dist = Math.abs(mid - viewMid);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        }
        return best;
      }

      function scrollToIndex(index, behavior) {
        if (!track || !allSlides[index]) return;
        var left = getSlideScrollLeft(index);
        if (!behavior || behavior === 'auto') {
          jumpWithoutSnap(index);
          return;
        }
        looping = true;
        track.style.scrollSnapType = 'none';
        track.scrollTo({ left: left, behavior: behavior });
        clearTimeout(scrollToIndex._timer);
        scrollToIndex._timer = setTimeout(function () {
          track.style.scrollSnapType = '';
          looping = false;
        }, 450);
      }

      function jumpWithoutSnap(index) {
        if (!track || !allSlides[index]) return;
        looping = true;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = getSlideScrollLeft(index);
        track.style.scrollSnapType = '';
        requestAnimationFrame(function () {
          looping = false;
        });
      }

      function checkLoop() {
        if (looping || totalSlides < 2 || isDesktopGallery() || isUnicePdp) return;
        var idx = getScrollIndex();
        if (idx === 0) {
          jumpWithoutSnap(totalSlides);
          setActiveIndex(totalSlides - 1);
        } else if (idx === totalSlides + 1) {
          jumpWithoutSnap(1);
          setActiveIndex(0);
        } else if (idx >= 1 && idx <= totalSlides) {
          setActiveIndex(idx - 1);
        }
      }

      function goToSlide(realIndex, behavior) {
        if (totalSlides < 2) return;
        /* Unice: no clone loop — slide index === real index */
        var scrollIndex = isDesktopGallery() || isUnicePdp ? realIndex : realIndex + 1;
        scrollToIndex(scrollIndex, behavior);
        setActiveIndex(realIndex);
      }

      function setupInfiniteLoop() {
        if (totalSlides < 2 || !track) return;

        /* Unice horizontal gallery: skip clones — they broke .u-pdp__slide queries */
        if (isUnicePdp) {
          teardownInfiniteLoop();
          allSlides = realSlides;
          jumpWithoutSnap(activeIndex);
          setActiveIndex(activeIndex);
          return;
        }

        if (isDesktopGallery()) {
          teardownInfiniteLoop();
          allSlides = realSlides;
          jumpWithoutSnap(activeIndex);
          setActiveIndex(activeIndex);
          return;
        }

        if (hasInfiniteClones) return;

        var firstClone = realSlides[0].cloneNode(true);
        var lastClone = realSlides[totalSlides - 1].cloneNode(true);
        firstClone.setAttribute('data-q-slide-clone', 'first');
        lastClone.setAttribute('data-q-slide-clone', 'last');
        firstClone.removeAttribute('id');
        lastClone.removeAttribute('id');

        track.insertBefore(lastClone, realSlides[0]);
        track.appendChild(firstClone);
        allSlides = track.querySelectorAll('[data-q-slide]');
        hasInfiniteClones = true;

        jumpWithoutSnap(activeIndex + 1);
        setActiveIndex(activeIndex);
      }

      function syncThumbsHeight() {
        var thumbsEl = gallery.querySelector('[data-q-gallery-thumbs]');
        var stageEl = gallery.querySelector('.q-pdp__stage, .u-pdp__stage');
        if (!thumbsEl || !stageEl) return;
        if (!isDesktopGallery()) {
          thumbsEl.style.maxHeight = '';
          return;
        }
        var h = stageEl.offsetHeight;
        if (h > 0) thumbsEl.style.maxHeight = h + 'px';
      }

      function syncGalleryLayout() {
        if (!track) return;
        syncThumbsHeight();
        if (totalSlides < 2) return;
        requestAnimationFrame(function () {
          goToSlide(activeIndex, 'auto');
          syncThumbsHeight();
        });
      }

      function onGalleryScroll() {
        if (scrollTicking || looping) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
          var idx = getScrollIndex();
          if (isDesktopGallery() || isUnicePdp) {
            if (idx >= 0 && idx < totalSlides) setActiveIndex(idx);
          } else if (idx >= 1 && idx <= totalSlides) {
            setActiveIndex(idx - 1);
          }
          scrollTicking = false;
        });
      }

      var scrollEndTimer;
      function onGalleryScrollEnd() {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(checkLoop, 80);
      }

      if (track) {
        track.addEventListener('scroll', onGalleryScroll, { passive: true });
        track.addEventListener('scroll', onGalleryScrollEnd, { passive: true });
        if ('onscrollend' in track) {
          track.addEventListener('scrollend', checkLoop, { passive: true });
        }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = parseInt(thumb.getAttribute('data-q-gallery-thumb'), 10);
          goToSlide(idx, isDesktopGallery() ? 'auto' : 'smooth');
        });
      });

      gallery.querySelectorAll('[data-q-gallery-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-q-gallery-dot'), 10);
          if (isNaN(idx)) return;
          goToSlide(idx, 'smooth');
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          if (totalSlides < 2) return;
          var next = (activeIndex - 1 + totalSlides) % totalSlides;
          goToSlide(next, isDesktopGallery() ? 'auto' : 'smooth');
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (totalSlides < 2) return;
          var next = (activeIndex + 1) % totalSlides;
          goToSlide(next, isDesktopGallery() ? 'auto' : 'smooth');
        });
      }

      /* Image lightbox — Unice black stage + thumbs; classic keeps white header UI */
      var lightbox = pdp.querySelector('[data-q-lightbox]');
      var isUniceLightbox = !!(lightbox && lightbox.classList.contains('u-lightbox'));
      var lbTrack = lightbox && lightbox.querySelector('[data-q-lightbox-track]');
      var lbSlides = lbTrack ? lbTrack.querySelectorAll('[data-q-lightbox-slide]') : [];
      var lbCounter = lightbox && lightbox.querySelector('[data-q-lightbox-counter]');
      var lbPrev = lightbox && lightbox.querySelector('[data-q-lightbox-prev]');
      var lbNext = lightbox && lightbox.querySelector('[data-q-lightbox-next]');
      var lbThumbsEl = lightbox && lightbox.querySelector('[data-q-lightbox-thumbs]');
      var lbThumbsBar = lightbox && lightbox.querySelector('[data-q-lightbox-thumbs-bar]');
      var lbThumbPrev = lightbox && lightbox.querySelector('[data-q-lightbox-thumb-prev]');
      var lbThumbNext = lightbox && lightbox.querySelector('[data-q-lightbox-thumb-next]');
      var lbTotal = lbSlides.length;
      var lastFocus = null;
      var lbScrollTicking = false;
      var lbMode = 'gallery';
      var lbGalleryHtml = null;
      var lbThumbsHtml = null;

      function refreshLbSlides() {
        lbSlides = lbTrack ? lbTrack.querySelectorAll('[data-q-lightbox-slide]') : [];
        lbTotal = lbSlides.length;
        if (lbPrev) lbPrev.hidden = lbTotal < 2;
        if (lbNext) lbNext.hidden = lbTotal < 2;
        if (lbThumbsBar) lbThumbsBar.hidden = lbTotal < 2;
      }

      function getLbIndex() {
        if (!lbTrack || !lbSlides.length) return 0;
        var w = lbTrack.offsetWidth;
        if (!w) return 0;
        return Math.max(0, Math.min(lbSlides.length - 1, Math.round(lbTrack.scrollLeft / w)));
      }

      function updateLbCounter(index) {
        if (lbCounter && lbTotal > 0) {
          if (isUniceLightbox) {
            lbCounter.textContent = (index + 1) + ' / ' + lbTotal;
          } else {
            lbCounter.textContent = (index + 1) + ' of ' + lbTotal;
          }
        }
        if (!lightbox) return;
        lightbox.querySelectorAll('[data-q-lightbox-dot]').forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function syncLbThumbNav() {
        if (!lbThumbsEl) return;
        var maxScroll = lbThumbsEl.scrollWidth - lbThumbsEl.clientWidth;
        if (lbThumbPrev) {
          if (maxScroll <= 2) lbThumbPrev.hidden = true;
          else lbThumbPrev.hidden = lbThumbsEl.scrollLeft <= 2;
        }
        if (lbThumbNext) {
          if (maxScroll <= 2) lbThumbNext.hidden = true;
          else lbThumbNext.hidden = lbThumbsEl.scrollLeft >= maxScroll - 2;
        }
      }

      function setLbActiveThumb(index) {
        if (!lbThumbsEl) return;
        var thumbs = lbThumbsEl.querySelectorAll('[data-q-lightbox-thumb]');
        thumbs.forEach(function (thumb, i) {
          var active = i === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        var activeThumb = thumbs[index];
        if (activeThumb && typeof lbThumbsEl.scrollTo === 'function') {
          var left = activeThumb.offsetLeft - (lbThumbsEl.clientWidth - activeThumb.offsetWidth) / 2;
          lbThumbsEl.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
        syncLbThumbNav();
      }

      function scrollLbTo(index, behavior) {
        if (!lbTrack || !lbSlides[index]) return;
        lbTrack.scrollTo({ left: lbSlides[index].offsetLeft, behavior: behavior || 'smooth' });
        updateLbCounter(index);
        setLbActiveThumb(index);
      }

      function rebuildLbThumbsFromSlides() {
        if (!lbThumbsEl || !isUniceLightbox) return;
        lbThumbsEl.innerHTML = '';
        lbSlides.forEach(function (slide, i) {
          var srcImg = slide.querySelector('img');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'u-lightbox__thumb' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('data-q-lightbox-thumb', String(i));
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + lbSlides.length);
          btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          if (srcImg) {
            var thumb = document.createElement('img');
            thumb.className = 'u-lightbox__thumb-img';
            thumb.src = srcImg.currentSrc || srcImg.src;
            thumb.alt = '';
            thumb.loading = 'lazy';
            btn.appendChild(thumb);
          }
          lbThumbsEl.appendChild(btn);
        });
        if (lbThumbsBar) lbThumbsBar.hidden = lbSlides.length < 2;
        bindLbThumbClicks();
        syncLbThumbNav();
      }

      function bindLbThumbClicks() {
        if (!lbThumbsEl) return;
        lbThumbsEl.querySelectorAll('[data-q-lightbox-thumb]').forEach(function (thumb) {
          thumb.onclick = function () {
            var idx = parseInt(thumb.getAttribute('data-q-lightbox-thumb'), 10);
            if (!isNaN(idx)) scrollLbTo(idx, 'smooth');
          };
        });
      }

      function openLightbox(zoomIndex) {
        if (!lightbox || !lbTrack || lbTotal === 0) return;
        lastFocus = document.activeElement;
        var idx = Math.max(0, Math.min(lbTotal - 1, parseInt(zoomIndex, 10) || 0));
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('q-lightbox-open');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            scrollLbTo(idx, 'auto');
            syncLbThumbNav();
          });
        });
        var closeBtn = lightbox.querySelector('[data-q-lightbox-close]');
        if (closeBtn) closeBtn.focus();
      }

      function restoreGalleryLightbox() {
        if (lbMode !== 'desc' || !lbTrack || lbGalleryHtml === null) return;
        lbTrack.innerHTML = lbGalleryHtml;
        lbGalleryHtml = null;
        if (lbThumbsEl && lbThumbsHtml !== null) {
          lbThumbsEl.innerHTML = lbThumbsHtml;
          lbThumbsHtml = null;
          bindLbThumbClicks();
        }
        lbMode = 'gallery';
        refreshLbSlides();
      }

      function openDescLightbox(images, startIndex) {
        if (!lightbox || !lbTrack || !images || !images.length) return;
        if (lbMode !== 'desc') {
          lbGalleryHtml = lbTrack.innerHTML;
          if (lbThumbsEl) lbThumbsHtml = lbThumbsEl.innerHTML;
          lbTrack.innerHTML = '';
          images.forEach(function (img) {
            var slide = document.createElement('div');
            slide.className = isUniceLightbox
              ? 'q-lightbox__slide u-lightbox__slide'
              : 'q-lightbox__slide';
            slide.setAttribute('data-q-lightbox-slide', '');
            var full = document.createElement('img');
            full.className = isUniceLightbox
              ? 'q-lightbox__img u-lightbox__img'
              : 'q-lightbox__img';
            full.src = img.currentSrc || img.src;
            full.alt = img.alt || '';
            full.decoding = 'async';
            slide.appendChild(full);
            lbTrack.appendChild(slide);
          });
          lbMode = 'desc';
          refreshLbSlides();
          rebuildLbThumbsFromSlides();
        }
        openLightbox(startIndex);
      }

      function closeLightbox() {
        if (!lightbox) return;
        var lbIndex = getLbIndex();
        var lbSlide = lbSlides[lbIndex];
        var mediaIndex = lbSlide && lbSlide.getAttribute('data-q-media-index');
        var wasDesc = lbMode === 'desc';
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('q-lightbox-open');
        restoreGalleryLightbox();
        if (!wasDesc && mediaIndex !== null && totalSlides > 1) {
          goToSlide(parseInt(mediaIndex, 10), 'auto');
        }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      function onLbScroll() {
        if (lbScrollTicking) return;
        lbScrollTicking = true;
        requestAnimationFrame(function () {
          var idx = getLbIndex();
          updateLbCounter(idx);
          setLbActiveThumb(idx);
          lbScrollTicking = false;
        });
      }

      function imageFileKey(url) {
        if (!url) return '';
        var path = String(url).split('?')[0];
        try {
          path = new URL(url, window.location.href).pathname;
        } catch (err) {
          /* keep path */
        }
        var base = path.split('/').pop() || '';
        return base
          .replace(/_\d+x(?=\.[a-z]+$)/i, '')
          .replace(/\.(webp|jpe?g|png|gif|avif)$/i, '')
          .toLowerCase();
      }

      function bindDescriptionImageZoom() {
        var roots = [];
        var classic = document.querySelector('.q-pdp__description');
        var uniceDesc = document.querySelector('[data-u-desc]');
        if (classic) roots.push(classic);
        if (uniceDesc) roots.push(uniceDesc);
        if (!roots.length || !lightbox || !lbTrack) return;

        var zoomMap = {};
        pdp.querySelectorAll('.q-pdp__slide-media--zoomable[data-q-zoom-index]').forEach(function (el) {
          var src = el.getAttribute('data-q-zoom-src') || '';
          var img = el.querySelector('img');
          var key = imageFileKey(src) || imageFileKey(img && (img.currentSrc || img.src));
          if (key) zoomMap[key] = el.getAttribute('data-q-zoom-index');
        });

        function markDescImages(description) {
          description.querySelectorAll('img').forEach(function (img) {
            img.classList.add('q-pdp-desc-img--zoomable');
            img.setAttribute('role', 'button');
            img.setAttribute('tabindex', '0');
            img.setAttribute('aria-label', (img.alt || 'Product image') + ' — enlarge');
          });
        }

        function openFromDescImage(description, img) {
          if (!img || !description.contains(img)) return;
          var key = imageFileKey(img.currentSrc || img.src);
          if (key && zoomMap[key] != null) {
            restoreGalleryLightbox();
            openLightbox(zoomMap[key]);
            return;
          }
          var images = Array.prototype.slice.call(description.querySelectorAll('img'));
          var idx = images.indexOf(img);
          if (idx < 0) return;
          openDescLightbox(images, idx);
        }

        roots.forEach(function (description) {
          markDescImages(description);
          if (description.dataset.qDescZoomBound === '1') return;
          description.dataset.qDescZoomBound = '1';
          description.addEventListener('click', function (e) {
            var img = e.target.closest('img');
            if (!img || !description.contains(img)) return;
            e.preventDefault();
            openFromDescImage(description, img);
          });
          description.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            var img = e.target.closest('img');
            if (!img || !description.contains(img)) return;
            e.preventDefault();
            openFromDescImage(description, img);
          });
        });

        window.qBindPdpDescriptionZoom = function () {
          roots.forEach(markDescImages);
          var fresh = document.querySelector('[data-u-desc]');
          if (fresh && fresh.dataset.qDescZoomBound !== '1') {
            fresh.dataset.qDescZoomBound = '';
            bindDescriptionImageZoom();
          } else if (fresh) {
            markDescImages(fresh);
          }
        };
      }

      if (track && lightbox && lbTrack) {
        track.addEventListener('click', function (e) {
          if (e.target.closest('[data-q-gallery-prev], [data-q-gallery-next], [data-q-wish]')) return;
          var media = e.target.closest('.q-pdp__slide-media--zoomable');
          if (!media) return;
          restoreGalleryLightbox();
          var zoomIndex = media.getAttribute('data-q-zoom-index');
          openLightbox(zoomIndex);
        });

        lightbox.querySelectorAll('[data-q-lightbox-close]').forEach(function (el) {
          el.addEventListener('click', closeLightbox);
        });

        if (lbPrev) {
          lbPrev.addEventListener('click', function () {
            var idx = getLbIndex();
            if (idx > 0) scrollLbTo(idx - 1, 'smooth');
          });
        }

        if (lbNext) {
          lbNext.addEventListener('click', function () {
            var idx = getLbIndex();
            if (idx < lbTotal - 1) scrollLbTo(idx + 1, 'smooth');
          });
        }

        bindLbThumbClicks();
        if (lbThumbsEl) {
          lbThumbsEl.addEventListener('scroll', syncLbThumbNav, { passive: true });
        }
        if (lbThumbPrev) {
          lbThumbPrev.addEventListener('click', function () {
            if (!lbThumbsEl) return;
            lbThumbsEl.scrollBy({ left: -160, behavior: 'smooth' });
            setTimeout(syncLbThumbNav, 320);
          });
        }
        if (lbThumbNext) {
          lbThumbNext.addEventListener('click', function () {
            if (!lbThumbsEl) return;
            lbThumbsEl.scrollBy({ left: 160, behavior: 'smooth' });
            setTimeout(syncLbThumbNav, 320);
          });
        }

        lbTrack.addEventListener('scroll', onLbScroll, { passive: true });

        lightbox.querySelectorAll('[data-q-lightbox-dot]').forEach(function (dot) {
          dot.addEventListener('click', function () {
            var idx = parseInt(dot.getAttribute('data-q-lightbox-dot'), 10);
            if (!isNaN(idx)) scrollLbTo(idx, 'smooth');
          });
        });

        document.addEventListener('keydown', function (e) {
          if (lightbox.hidden) return;
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft') scrollLbTo(Math.max(0, getLbIndex() - 1), 'smooth');
          if (e.key === 'ArrowRight') scrollLbTo(Math.min(lbTotal - 1, getLbIndex() + 1), 'smooth');
        });

        bindDescriptionImageZoom();
        window.qOpenPdpLightbox = openLightbox;
      }

      setActiveIndex(0);
      setupInfiniteLoop();
      window.addEventListener('load', syncGalleryLayout);
      galleryDesktopMq.addEventListener('change', function () {
        setupInfiniteLoop();
        syncGalleryLayout();
      });

      window.addEventListener('resize', function () {
        if (totalSlides < 2) return;
        if (!isDesktopGallery()) {
          var idx = getScrollIndex();
          if (idx < 1 || idx > totalSlides) {
            var real = idx === 0 ? totalSlides - 1 : 0;
            jumpWithoutSnap(real + 1);
            setActiveIndex(real);
          }
        }
        syncGalleryLayout();
      });
    }
  }

  /* Product card — swatch click switches main image + price */
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-q-card-swatch]');
    if (!swatch) return;
    if (!swatch.dataset.imageUrl && !swatch.dataset.price) return;
    event.preventDefault();
    event.stopPropagation();
    var card = swatch.closest('[data-q-card]');
    if (!card) return;

    if (swatch.dataset.imageUrl) {
      var img = card.querySelector('.q-card__img');
      if (img) {
        var url600 = swatch.dataset.imageUrl;
        var url352 = swatch.dataset.imageUrl352 || url600.replace('width=600', 'width=352');
        img.src = url600;
        img.srcset = url352 + ' 352w, ' + url600 + ' 600w';
      }
      var wishBtn = card.querySelector('[data-q-wish]');
      if (wishBtn) {
        wishBtn.dataset.productImage = swatch.dataset.imageUrl;
      }
    }

    if (swatch.dataset.price) {
      var priceText = card.querySelector('[data-q-card-price-text]');
      if (priceText) {
        priceText.textContent = swatch.dataset.price;
      }
      var wishBtnPrice = card.querySelector('[data-q-wish]');
      if (wishBtnPrice) {
        wishBtnPrice.dataset.productPrice = swatch.dataset.price;
      }
    }

    card.querySelectorAll('[data-q-card-swatch]').forEach(function (btn) {
      var active = btn === swatch;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  });

  function mergePlpFetchHtml(plp, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.querySelector('[data-q-plp-grid]');
    var grid = plp.querySelector('[data-q-plp-grid]');
    if (newGrid && grid) {
      grid.innerHTML = newGrid.innerHTML;
    }
    var newSentinel = doc.querySelector('[data-q-infinite-sentinel]');
    var sentinel = plp.querySelector('[data-q-infinite-sentinel]');
    if (sentinel && newSentinel && newSentinel.dataset.nextUrl) {
      sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
    } else if (sentinel && (!newSentinel || !newSentinel.dataset.nextUrl)) {
      sentinel.remove();
    } else if (!sentinel && newSentinel && newSentinel.dataset.nextUrl) {
      plp.appendChild(newSentinel.cloneNode(true));
    }
    if (window.qSyncWishButtons) window.qSyncWishButtons();
    if (window.qInitEzReviewStars) window.qInitEzReviewStars();
  }

  function bootstrapPlpFromCollection(plp) {
    var fetchBase = plp.dataset.qPlpFetch;
    var sectionId = plp.dataset.sectionId;
    if (!fetchBase || !sectionId) return Promise.resolve();
    var url = fetchBase + '&section_id=' + encodeURIComponent(sectionId) + '&page=1';
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('bootstrap failed');
        return res.text();
      })
      .then(function (html) {
        mergePlpFetchHtml(plp, html);
      })
      .catch(function () {});
  }

  function initPlpInfiniteScroll(plp) {
    var grid = plp.querySelector('[data-q-plp-grid]');
    var sentinel = plp.querySelector('[data-q-infinite-sentinel]');
    var sectionId = plp.dataset.sectionId;
    var loading = false;

    if (!grid || !sentinel || !sectionId) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || loading) return;
          var nextUrl = sentinel.dataset.nextUrl;
          if (!nextUrl) return;

          loading = true;
          sentinel.classList.add('is-loading');

          var url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', sectionId);

          fetch(url.toString())
            .then(function (res) {
              if (!res.ok) throw new Error('load failed');
              return res.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newGrid = doc.querySelector('[data-q-plp-grid]');
              if (newGrid) {
                newGrid.querySelectorAll('.q-card').forEach(function (card) {
                  grid.appendChild(card);
                });
                if (window.qSyncWishButtons) window.qSyncWishButtons();
                if (window.qInitEzReviewStars) window.qInitEzReviewStars();
              }
              var newSentinel = doc.querySelector('[data-q-infinite-sentinel]');
              if (newSentinel && newSentinel.dataset.nextUrl) {
                sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
              } else {
                observer.disconnect();
                sentinel.remove();
              }
            })
            .catch(function () {
              observer.disconnect();
            })
            .finally(function () {
              loading = false;
              if (sentinel.parentNode) {
                sentinel.classList.remove('is-loading');
              }
            });
        });
      },
      { rootMargin: '600px 0px' }
    );

    observer.observe(sentinel);
  }

  /* PLP infinite scroll + homepage bootstrap (newest-first via collection fetch) */
  document.querySelectorAll('[data-q-plp-fetch]').forEach(function (plp) {
    bootstrapPlpFromCollection(plp).finally(function () {
      initPlpInfiniteScroll(plp);
    });
  });
  document.querySelectorAll('[data-q-plp]:not([data-q-plp-fetch])').forEach(initPlpInfiniteScroll);

  /* EZ Amazon Reviews Importer — Quince-style ★ 4.8 on PLP/PDP when review data exists */
  function extractEzRatingValue(el) {
    var root = el;
    if (el.nextElementSibling && el.nextElementSibling.classList.contains('rev-titl-wp')) {
      root = el.nextElementSibling;
    }
    var numEl = root.querySelector('.nub-rev-tt, .avg-rate, .ez-modern-score-big, [class*="average"]');
    if (numEl) {
      var numMatch = (numEl.textContent || '').match(/(\d+\.\d|\d+)/);
      if (numMatch) return parseFloat(numMatch[1]);
    }
    var textMatch = (root.textContent || '').match(/(\d+\.\d)/);
    return textMatch ? parseFloat(textMatch[1]) : null;
  }

  function normalizeEzRating(el) {
    if (el.classList.contains('q-rating--ez-normalized')) return;
    var value = extractEzRatingValue(el);
    if (!value || value <= 0) return;
    var display = (Math.round(value * 10) / 10).toFixed(1);
    var isCard = el.classList.contains('jstar-under-title-list');
    el.innerHTML =
      '<svg class="q-rating__icon" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 17.8 5.8 21l1.2-6.9-5-4.9 6.9-1z"/></svg>' +
      '<span class="q-rating__value">' +
      display +
      '</span>';
    el.classList.add(isCard ? 'q-rating--card' : 'q-rating--pdp', 'q-rating--ez-normalized');
    el.setAttribute('aria-label', 'Rated ' + display + ' out of 5');
  }

  function markEzRatingReady(el) {
    if (!el || el.classList.contains('q-rating--ez-ready')) return;
    var hasInner = el.innerHTML.trim().length > 0;
    var hasNextRev = el.nextElementSibling && el.nextElementSibling.classList.contains('rev-titl-wp');
    var hasInnerRev = !!el.querySelector('.rev-titl-wp, .nub-rev-tt, .dark-str-i, .fx-star-under-title-list');
    if (!hasInner && !hasNextRev && !hasInnerRev) return;
    normalizeEzRating(el);
    if (hasInner || hasInnerRev) {
      el.classList.add('q-rating--ez-ready');
    }
    if (hasNextRev) {
      el.nextElementSibling.classList.add('q-rating--ez-ready');
    }
  }

  function initEzReviewStars() {
    document.querySelectorAll('.jstar-under-pd-title, .jstar-under-title-list').forEach(markEzRatingReady);
  }

  function fetchEzCollectionRatings() {
    var placeholders = document.querySelectorAll('.jstar-under-title-list[data-product-id]:not(.q-rating--ez-ready)');
    if (!placeholders.length || !window.Shopify || !Shopify.shop) return;

    var productIds = [];
    placeholders.forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      if (id) productIds.push(id);
    });
    if (!productIds.length) return;

    var body = new URLSearchParams();
    productIds.forEach(function (id) {
      body.append('productIds[]', id);
    });
    body.append('storeUrl', window.location.href);

    fetch('https://dev.younet.network/importreview/ajaxStarUnderProductList?shop=' + Shopify.shop, {
      method: 'POST',
      body: body,
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        text = (text || '').trim();
        if (!text || text === '[]') return;
        var productStars = JSON.parse(text);
        Object.keys(productStars).forEach(function (productId) {
          var el = document.querySelector('.jstar-under-title-list[data-product-id="' + productId + '"]');
          if (!el || !productStars[productId] || !productStars[productId].content) return;
          el.innerHTML = productStars[productId].content;
          markEzRatingReady(el);
        });
      })
      .catch(function () {});
  }

  function observeEzReviewStars() {
    if (window.__qEzRatingObserver) return;
    window.__qEzRatingObserver = new MutationObserver(function () {
      initEzReviewStars();
    });
    document.querySelectorAll('.jstar-under-pd-title, .jstar-under-title-list').forEach(function (el) {
      window.__qEzRatingObserver.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  window.qInitEzReviewStars = initEzReviewStars;
  window.addEventListener('load', function () {
    initEzReviewStars();
    fetchEzCollectionRatings();
    setTimeout(initEzReviewStars, 800);
    setTimeout(fetchEzCollectionRatings, 1200);
  });
  observeEzReviewStars();

  /* EZ Amazon Reviews Importer — hide sort dropdown only */
  function hideEzReviewSort() {
    document.querySelectorAll('#sort_review').forEach(function (el) {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function ensurePdpDescriptionStyles() {
    if (!document.querySelector('.q-pdp__description')) return;
    if (document.getElementById('q-pdp-desc-divider-fix')) return;

    var style = document.createElement('style');
    style.id = 'q-pdp-desc-divider-fix';
    style.textContent =
      '.q-pdp__info .q-pdp__description{border-top:1px solid rgba(33,32,31,.08)!important;padding-top:1.5rem!important}' +
      '.q-pdp__info .q-pdp-reviews:not(.q-pdp-reviews--has-reviews){display:none!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}' +
      'body.q-template-product .ez-amrv-wrapp:has(#ez_review_containter[data-review="0"]){display:none!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}';
    document.head.appendChild(style);
  }

  function styleEzReviewUi() {
    ensurePdpDescriptionStyles();
    hideEzReviewSort();
    syncReviewsSectionVisibility();
    syncUniceReviewsBadge();
    runPdpDescriptionEnhancements();

    var loadBtn = document.getElementById('realoadMore');
    if (loadBtn) {
      var label = (loadBtn.textContent || '').replace(/\s+/g, ' ').trim();
      if (!label || label === '. . .' || label === '...') {
        loadBtn.textContent = 'LOAD MORE REVIEWS';
      }
      loadBtn.setAttribute('aria-label', 'Load more reviews');
    }
  }

  window.qHideEzReviewSort = hideEzReviewSort;
  window.qStyleEzReviewUi = styleEzReviewUi;
  window.qSyncUniceReviewsBadge = syncUniceReviewsBadge;
  document.addEventListener('DOMContentLoaded', function () {
    ensurePdpDescriptionStyles();
    styleEzReviewUi();
    runPdpDescriptionEnhancements();
    watchUniceReviewsBadge();
  });
  window.addEventListener('load', function () {
    ensurePdpDescriptionStyles();
    styleEzReviewUi();
    runPdpDescriptionEnhancements();
    watchUniceReviewsBadge();
  });

  function syncReviewsSectionVisibility() {
    var section = document.querySelector('.q-pdp-reviews');
    if (!section) return;

    /* UNice PDP: keep reviews card visible so EZ widget can paint into it */
    if (section.hasAttribute('data-u-reviews') || section.closest('[data-u-pdp]')) {
      section.removeAttribute('hidden');
      section.classList.add('q-pdp-reviews--has-reviews');
      section.classList.remove('q-pdp-reviews--empty');
      syncUniceReviewsBadge();
      syncUniceReviewsEmptyState();
      return;
    }

    var container = document.getElementById('ez_review_containter');
    var reviewCountRaw = container ? container.getAttribute('data-review') : null;
    var reviewCount =
      reviewCountRaw !== null && reviewCountRaw !== '' ? parseInt(reviewCountRaw, 10) : null;

    var hasReviews = reviewCount !== null && !isNaN(reviewCount) && reviewCount > 0;

    if (hasReviews) {
      section.classList.add('q-pdp-reviews--has-reviews');
      section.classList.remove('q-pdp-reviews--empty');
      section.removeAttribute('hidden');
    } else if (reviewCount === 0) {
      section.classList.add('q-pdp-reviews--empty');
      section.classList.remove('q-pdp-reviews--has-reviews');
      section.setAttribute('hidden', '');
    } else {
      var wrapper = document.getElementById('aliexpress-review-wrapper-sp');
      var wrapperLoaded = wrapper && wrapper.innerHTML.trim().length > 0;
      if (!wrapperLoaded) return;

      section.classList.add('q-pdp-reviews--empty');
      section.classList.remove('q-pdp-reviews--has-reviews');
      section.setAttribute('hidden', '');
    }

    document.querySelectorAll('.ez-amrv-wrapp, #ra-dt-wrpp').forEach(function (widget) {
      var ezContainer = widget.querySelector('#ez_review_containter') || widget;
      var countRaw = ezContainer.getAttribute('data-review');
      var count = countRaw !== null && countRaw !== '' ? parseInt(countRaw, 10) : null;
      if (count === 0) {
        widget.setAttribute('hidden', '');
        widget.style.setProperty('display', 'none', 'important');
        widget.style.setProperty('height', '0', 'important');
        widget.style.setProperty('margin', '0', 'important');
        widget.style.setProperty('padding', '0', 'important');
      }
    });
  }

  function syncUniceReviewsBadge() {
    var badge = document.querySelector('[data-u-reviews-badge]');
    if (!badge) return false;

    var ratingEl = badge.querySelector('[data-u-rating-value]');
    var countEl = badge.querySelector('[data-u-reviews-count]');
    var fillEl = badge.querySelector('[data-u-stars-fill]');

    var rating = null;
    var count = null;
    var root =
      document.getElementById('aliexpress-review-wrapper-sp') ||
      document.querySelector('.ez-amrv-wrapp, #ra-dt-wrpp, [data-u-reviews]');
    if (!root) return false;

    var container =
      document.getElementById('ez_review_containter') ||
      root.querySelector('[data-review], #ez_review_containter');
    if (container) {
      var countRaw = container.getAttribute('data-review');
      if (countRaw !== null && countRaw !== '') {
        var parsedCount = parseInt(countRaw, 10);
        if (!isNaN(parsedCount) && parsedCount >= 0) count = parsedCount;
      }
    }

    var scoreSelectors = [
      '.ez-modern-score-big',
      '.avg-rate',
      '.nub-rev-tt',
      '.average-rating',
      '[class*="score-big"]',
      '[class*="avg"]',
      '[class*="rating-score"]'
    ];
    for (var i = 0; i < scoreSelectors.length; i++) {
      var scoreEl = root.querySelector(scoreSelectors[i]);
      if (!scoreEl) continue;
      var scoreMatch = String(scoreEl.textContent || '').match(/(\d+(?:\.\d+)?)/);
      if (!scoreMatch) continue;
      var parsedScore = parseFloat(scoreMatch[1]);
      if (!isNaN(parsedScore) && parsedScore > 0 && parsedScore <= 5) {
        rating = parsedScore;
        break;
      }
    }

    var text = String(root.textContent || '').replace(/\s+/g, ' ');
    if (count == null) {
      var basedMatch = text.match(/Based on\s+(\d+)\s+reviews?/i);
      if (basedMatch) count = parseInt(basedMatch[1], 10);
    }
    if (rating == null) {
      var nearBased = text.match(/([1-5](?:\.\d)?)\s*(?:★★★★★|★+|stars?)?\s*Based on\s+\d+/i);
      if (nearBased) rating = parseFloat(nearBased[1]);
    }
    if (rating == null) {
      /* Fallback: first standalone 1–5 near review summary block */
      var leafScores = root.querySelectorAll('span, div, strong, b, p');
      for (var j = 0; j < leafScores.length; j++) {
        var leaf = leafScores[j];
        if (leaf.children && leaf.children.length > 0) continue;
        var leafText = String(leaf.textContent || '').trim();
        if (!/^[1-5](?:\.\d)?$/.test(leafText)) continue;
        var fs = 0;
        try {
          fs = parseFloat(window.getComputedStyle(leaf).fontSize) || 0;
        } catch (e) {}
        if (fs >= 18) {
          rating = parseFloat(leafText);
          break;
        }
      }
    }

    if (rating == null && count == null) return false;

    if (rating != null && ratingEl) {
      var display = Math.round(rating * 10) / 10;
      var displayText = Number.isInteger(display) ? String(display) : display.toFixed(1);
      ratingEl.textContent = displayText;
      ratingEl.hidden = false;
      ratingEl.removeAttribute('hidden');
      if (fillEl) fillEl.style.width = Math.max(0, Math.min(100, display * 20)) + '%';
      badge.setAttribute(
        'aria-label',
        'Rated ' + displayText + ' out of 5' + (count != null && count > 0 ? ', ' + count + ' reviews' : '')
      );
    }

    if (count != null && countEl) {
      countEl.textContent = count > 0 ? count + ' Reviews' : 'Be the first';
      if (count <= 0) {
        badge.setAttribute('aria-label', 'Be the first to review');
      }
    }
    syncUniceReviewsEmptyState(count);
    return rating != null || count != null;
  }

  function syncUniceReviewsEmptyState(countOverride) {
    var empty = document.querySelector('[data-u-reviews-empty]');
    if (!empty) return;

    var count = countOverride;
    if (count == null) {
      var container = document.getElementById('ez_review_containter');
      var raw = container ? container.getAttribute('data-review') : null;
      if (raw !== null && raw !== '') {
        var parsed = parseInt(raw, 10);
        if (!isNaN(parsed)) count = parsed;
      }
    }

    if (count != null && count > 0) {
      empty.hidden = true;
      empty.setAttribute('hidden', '');
      empty.style.display = 'none';
    } else if (count === 0) {
      empty.hidden = false;
      empty.removeAttribute('hidden');
      empty.style.display = '';
    }
  }

  function watchUniceReviewsBadge() {
    if (!document.querySelector('[data-u-reviews-badge]')) return;
    syncUniceReviewsBadge();
    syncUniceReviewsEmptyState();

    var wrap = document.getElementById('aliexpress-review-wrapper-sp');
    var target = wrap || document.querySelector('[data-u-reviews]') || document.body;
    if (target && !target.__uReviewsBadgeObserved) {
      target.__uReviewsBadgeObserved = true;
      var obs = new MutationObserver(function () {
        syncUniceReviewsBadge();
        syncUniceReviewsEmptyState();
      });
      obs.observe(target, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-review', 'class']
      });
    }

    var tries = 0;
    var timer = setInterval(function () {
      var ok = syncUniceReviewsBadge();
      syncUniceReviewsEmptyState();
      tries += 1;
      if (ok || tries >= 40) clearInterval(timer);
    }, 500);
  }

  function collapseEmptyDescriptionBlocks() {
    var description = document.querySelector('.q-pdp__description');
    if (!description) return;

    var selectors =
      'h1, h2, h3, h4, p, div.detailmodule_html, div.detail-desc-decorate-richtext, span.slate-node-text';
    var changed = true;
    var passes = 0;

    while (changed && passes < 8) {
      changed = false;
      passes += 1;
      description.querySelectorAll(selectors).forEach(function (el) {
        if (el.closest('.q-pdp__description') !== description && !description.contains(el)) return;
        var text = (el.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, '').trim();
        var hasMedia = el.querySelector('img, video, iframe, svg, picture, table');
        if (!text && !hasMedia && el.parentNode) {
          el.parentNode.removeChild(el);
          changed = true;
        }
      });
    }
  }

  function titleCaseLabel(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/(?:^|\s|[-/])\w/g, function (ch) {
        return ch.toUpperCase();
      });
  }

  function cleanMarketingText(text) {
    return String(text || '')
      .replace(/[\u{1F300}-\u{1F9FF}]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatFeatureValue(value) {
    value = cleanMarketingText(value);
    if (/\d+%:\s/.test(value)) {
      var parts = value.split(/(?=\d+%:\s)/);
      if (parts.length >= 2) {
        var items = parts
          .map(function (part) {
            var match = part.match(/^(\d+%):\s*(.+)$/);
            if (match) {
              return (
                '<li><strong>' +
                escapeDescHtml(match[1]) +
                '</strong> ' +
                escapeDescHtml(match[2].trim()) +
                '</li>'
              );
            }
            return part.trim() ? '<li>' + escapeDescHtml(part.trim()) + '</li>' : '';
          })
          .filter(Boolean)
          .join('');
        if (items) {
          return '<ul class="q-pdp-feature-card__list">' + items + '</ul>';
        }
      }
    }
    return escapeDescHtml(value);
  }

  function stripInlineBrackets(text) {
    return cleanMarketingText(text)
      .replace(/[【\[][^\]]+[\]】]:?\s*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseBracketBlocks(text) {
    var cleaned = cleanMarketingText(text);
    var re = /[【\[]([^\]]+)[\]】]:?\s*/g;
    var hits = [];
    var match;
    while ((match = re.exec(cleaned)) !== null) {
      hits.push({ name: match[1].trim(), index: match.index, valStart: match.index + match[0].length });
    }
    if (hits.length < 2) return null;

    var rows = [];
    for (var i = 0; i < hits.length; i += 1) {
      var end = i + 1 < hits.length ? hits[i + 1].index : cleaned.length;
      var value = cleaned.slice(hits[i].valStart, end).replace(/^:\s*/, '').trim();
      if (value) {
        rows.push({ name: titleCaseLabel(hits[i].name), value: value });
      }
    }
    if (rows.length < 2) return null;

    var lead = cleaned.slice(0, hits[0].index).replace(/[?:]\s*$/, '').trim();
    return {
      sectionTitle: "Why You'll Love It",
      lead: lead,
      rows: rows
    };
  }

  function parseLabelBody(text) {
    var cleaned = cleanMarketingText(text);
    var match = cleaned.match(/^(.{6,80}?):\s*(.+)$/);
    if (!match) return null;
    return { name: match[1].trim(), body: match[2].trim() };
  }

  function parseProseFeatureBlocks(text) {
    var cleaned = cleanMarketingText(text);
    var labelRe = /(?:^|\s)([A-Z][^:]{4,80}?):\s+/g;
    var hits = [];
    var match;
    while ((match = labelRe.exec(cleaned)) !== null) {
      var label = match[1].trim();
      if (label.split(/\s+/).length > 10) continue;
      hits.push({
        name: label,
        labelStart: match.index,
        valStart: match.index + match[0].length
      });
    }
    if (hits.length < 2) return null;

    var rows = [];
    for (var i = 0; i < hits.length; i += 1) {
      var end = i + 1 < hits.length ? hits[i + 1].labelStart : cleaned.length;
      var value = cleaned.slice(hits[i].valStart, end).trim();
      if (hits[i].name && value) {
        rows.push({ name: titleCaseLabel(hits[i].name), value: value });
      }
    }
    return rows.length >= 2 ? rows : null;
  }

  function parseMarketingBlocks(text) {
    var cleaned = cleanMarketingText(text);
    var bracketMatch = cleaned.match(/[【\[]([^\]]+)[\]】]/);
    var sectionTitle = bracketMatch ? bracketMatch[1].trim() : '';
    if (bracketMatch) {
      cleaned = cleaned.replace(/[【\[][^\]]+[\]】]\s*/, '').trim();
    }

    var labelRe = /([A-Z][A-Z0-9\s/&'()-]{2,48}):\s*/g;
    var hits = [];
    var match;
    while ((match = labelRe.exec(cleaned)) !== null) {
      var label = match[1].trim();
      var letters = label.replace(/[^a-zA-Z]/g, '');
      var caps = (label.match(/[A-Z]/g) || []).length;
      if (letters.length >= 3 && caps / letters.length >= 0.65) {
        hits.push({ name: label, index: match.index, valStart: match.index + match[0].length });
      }
    }
    if (hits.length < 2) return null;

    var rows = [];
    for (var i = 0; i < hits.length; i += 1) {
      var end = i + 1 < hits.length ? hits[i + 1].index : cleaned.length;
      var value = cleaned.slice(hits[i].valStart, end).trim();
      value = value.replace(/\s+\d+\s+density(\s+\d+\s+density)*\s*$/i, '').trim();
      if (value) {
        rows.push({ name: titleCaseLabel(hits[i].name), value: value });
      }
    }
    if (rows.length < 2) return null;

    var lead = cleaned.slice(0, hits[0].index).replace(/[?:]\s*$/, '').trim();
    return {
      sectionTitle: sectionTitle || "Why You'll Love It",
      lead: lead,
      rows: rows
    };
  }

  function buildMarketingSection(blocks) {
    var frag = document.createDocumentFragment();
    var heading = document.createElement('h3');
    heading.textContent = blocks.sectionTitle;
    frag.appendChild(heading);

    if (blocks.lead) {
      var lead = document.createElement('p');
      lead.className = 'q-pdp-desc-lead';
      lead.textContent = blocks.lead;
      frag.appendChild(lead);
    }

    var list = document.createElement('ul');
    list.className = 'q-pdp-feature-cards';
    blocks.rows.forEach(function (row, idx) {
      var content = resolveFeatureContent(row.name, row.value);
      var li = document.createElement('li');
      li.className = 'q-pdp-feature-card';
      li.innerHTML =
        '<span class="q-pdp-feature-card__num">' +
        String(idx + 1).padStart(2, '0') +
        '</span>' +
        '<div class="q-pdp-feature-card__content">' +
        '<p class="q-pdp-feature-card__title">' +
        escapeDescHtml(content.title) +
        '</p>' +
        '<div class="q-pdp-feature-card__text">' +
        formatFeatureValue(content.body) +
        '</div>' +
        '</div>';
      list.appendChild(li);
    });
    frag.appendChild(list);
    return frag;
  }

  function convertMarketingParagraph(p) {
    if (!p || p.querySelector('img, video, iframe')) return false;
    var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.length < 80) return false;
    var blocks = parseMarketingBlocks(text);
    if (!blocks) blocks = parseBracketBlocks(text);
    if (!blocks) {
      var proseRows = parseProseFeatureBlocks(text);
      if (proseRows) {
        blocks = {
          sectionTitle: "Why You'll Love It",
          lead: '',
          rows: proseRows
        };
      }
    }
    if (!blocks) return false;
    p.replaceWith(buildMarketingSection(blocks));
    return true;
  }

  function parseInlineSpecPairs(text) {
    var cleaned = (text || '').replace(/\s+/g, ' ').trim();
    cleaned = cleaned.replace(/^Description\s*:?\s*/i, '').trim();
    if (!cleaned) return null;

    var re = /\b([A-Z][a-z]+(?:\s+[A-Z][a-z]+){0,2}):\s*/g;
    var hits = [];
    var match;
    while ((match = re.exec(cleaned)) !== null) {
      hits.push({ name: match[1].trim(), index: match.index, valStart: match.index + match[0].length });
    }
    if (hits.length < 3) return null;

    var rows = [];
    for (var i = 0; i < hits.length; i += 1) {
      var end = i + 1 < hits.length ? hits[i + 1].index : cleaned.length;
      var value = cleaned.slice(hits[i].valStart, end).trim();
      var name = hits[i].name;
      if (!name || !value || value.length < 2) continue;
      if (name.length > 28 || name.split(/\s+/).length > 4) continue;
      if (value.split(/\s+/).length > 10) continue;
      rows.push({ name: name, value: value });
    }
    return rows.length >= 3 ? rows : null;
  }

  function buildSpecGrid(rows) {
    var grid = document.createElement('dl');
    grid.className = 'q-pdp-spec-grid';
    rows.forEach(function (row) {
      var item = document.createElement('div');
      item.className = 'q-pdp-spec-grid__item';
      item.innerHTML = '<dt>' + row.name + '</dt><dd>' + row.value + '</dd>';
      grid.appendChild(item);
    });
    return grid;
  }

  function escapeDescHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function smartFeatureTitle(label, value) {
    label = (label || '').trim();
    value = (value || '').trim();
    if (label && !/^Feature\s*\d+$/i.test(label)) return label;
    var colonMatch = value.match(/^(.{12,72}?):\s+/);
    if (colonMatch) return colonMatch[1].trim();
    var sentMatch = value.match(/^(.{24,90}?[.!?])/);
    if (sentMatch) return sentMatch[1].trim();
    var num = (label.match(/\d+/) || ['1'])[0];
    return 'Highlight ' + num;
  }

  function normalizeFeatureText(text) {
    return cleanMarketingText(text)
      .toLowerCase()
      .replace(/[^\w\s]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function stripFeatureLead(title, value) {
    value = cleanMarketingText(value);
    title = (title || '').trim();
    if (!value || !title) return value;

    var lowerVal = value.toLowerCase();
    var lowerTitle = title.toLowerCase();
    if (lowerVal.indexOf(lowerTitle) === 0) {
      var rest = value.slice(title.length).replace(/^[\s:.\-–—]+/, '').trim();
      if (rest) return rest;
    }

    var firstSent = value.match(/^(.+?[.!?])\s+/);
    if (firstSent) {
      var sentNorm = normalizeFeatureText(firstSent[1]);
      var titleNorm = normalizeFeatureText(title);
      if (
        sentNorm === titleNorm ||
        sentNorm.indexOf(titleNorm) === 0 ||
        titleNorm.indexOf(sentNorm) === 0
      ) {
        return value.slice(firstSent[0].length).trim();
      }
    }

    return value;
  }

  function resolveFeatureContent(name, value) {
    var title = smartFeatureTitle(name, value);
    var body = stripFeatureLead(title, value);
    if (!body) body = cleanMarketingText(value);
    return { title: title, body: body };
  }

  function isNarrativeRow(label, value) {
    return /^Feature\s*\d+$/i.test(label) || (value && value.length > 100);
  }

  function buildFeatureCards(rows) {
    var list = document.createElement('ul');
    list.className = 'q-pdp-feature-cards';
    rows.forEach(function (row, idx) {
      var content = resolveFeatureContent(row.name, row.value);
      var li = document.createElement('li');
      li.className = 'q-pdp-feature-card';
      li.innerHTML =
        '<span class="q-pdp-feature-card__num">' +
        String(idx + 1).padStart(2, '0') +
        '</span>' +
        '<div class="q-pdp-feature-card__content">' +
        '<p class="q-pdp-feature-card__title">' +
        escapeDescHtml(content.title) +
        '</p>' +
        '<div class="q-pdp-feature-card__text">' +
        formatFeatureValue(content.body) +
        '</div>' +
        '</div>';
      list.appendChild(li);
    });
    return list;
  }

  function parseTableRows(table) {
    var rows = [];
    table.querySelectorAll('tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('td, th');
      if (cells.length < 2) return;
      var name = (cells[0].textContent || '').replace(/\s+/g, ' ').trim();
      var value = (cells[1].textContent || '').replace(/\s+/g, ' ').trim();
      if (name && value) rows.push({ name: name, value: value });
    });
    return rows;
  }

  function normalizeSectionTitle(text) {
    var t = (text || '').trim().toLowerCase();
    if (t === 'specifications' || t === 'key features' || t === 'overview') {
      return '';
    }
    return text;
  }

  function convertHighlightsList(list) {
    var rows = [];
    list.querySelectorAll(':scope > li').forEach(function (li) {
      var strong = li.querySelector('strong');
      var title = strong ? strong.textContent.trim() : '';
      var body = (li.textContent || '').replace(/\s+/g, ' ').trim();
      if (strong) {
        body = body.replace(title, '').trim();
      }
      if (!body && title) body = title;
      if (body) rows.push({ name: title, value: body });
    });
    if (!rows.length) return null;
    return buildFeatureCards(rows);
  }

  function convertTable(table) {
    var rows = parseTableRows(table);
    if (!rows.length) return null;

    var narrative = [];
    var compact = [];
    rows.forEach(function (row) {
      if (isNarrativeRow(row.name, row.value)) {
        narrative.push(row);
      } else {
        compact.push(row);
      }
    });

    var wrap = document.createDocumentFragment();
    if (narrative.length) wrap.appendChild(buildFeatureCards(narrative));
    if (compact.length) wrap.appendChild(buildSpecGrid(compact));
    return wrap.childNodes.length ? wrap : null;
  }

  function restructurePdpDescription() {
    var description = document.querySelector('.q-pdp__description');
    if (!description || description.dataset.qDescRestructured === '1') return;

    description.querySelectorAll('p.q-pdp-desc-overview, .q-pdp-desc-section__body > p:not(:has(> img))').forEach(function (p) {
      convertMarketingParagraph(p);
    });

    description.querySelectorAll('table').forEach(function (table) {
      var replacement = convertTable(table);
      if (replacement) table.replaceWith(replacement);
    });

    description.querySelectorAll('.product-highlights').forEach(function (list) {
      var cards = convertHighlightsList(list);
      if (cards) list.replaceWith(cards);
    });

    description.querySelectorAll('.q-pdp-desc-specs').forEach(function (grid) {
      var rows = [];
      grid.querySelectorAll('.q-pdp-desc-specs__row').forEach(function (row) {
        var name = row.querySelector('.q-pdp-desc-specs__label');
        var value = row.querySelector('.q-pdp-desc-specs__value');
        if (name && value) {
          rows.push({
            name: name.textContent.trim(),
            value: value.textContent.trim()
          });
        }
      });
      if (!rows.length) return;
      var narrative = rows.filter(function (r) {
        return isNarrativeRow(r.name, r.value);
      });
      var compact = rows.filter(function (r) {
        return !isNarrativeRow(r.name, r.value);
      });
      var frag = document.createDocumentFragment();
      if (narrative.length) frag.appendChild(buildFeatureCards(narrative));
      if (compact.length) frag.appendChild(buildSpecGrid(compact));
      grid.replaceWith(frag);
    });

    var headings = description.querySelectorAll(':scope > h3');
    headings.forEach(function (h3) {
      var title = (h3.textContent || '').trim();
      var normalized = normalizeSectionTitle(title);
      if (title.toLowerCase() === 'specifications' && description.querySelector('.q-pdp-feature-cards')) {
        h3.textContent = "Why You'll Love It";
      } else if (title.toLowerCase() === 'key features') {
        h3.textContent = "Why You'll Love It";
      } else if (title.toLowerCase() === 'specifications' && description.querySelector('.q-pdp-spec-grid')) {
        h3.textContent = 'The Details';
      } else if (normalized) {
        h3.textContent = normalized;
      }

      var section = document.createElement('section');
      section.className = 'q-pdp-desc-section';
      h3.parentNode.insertBefore(section, h3);
      section.appendChild(h3);
      h3.className = 'q-pdp-desc-section__title';

      var body = document.createElement('div');
      body.className = 'q-pdp-desc-section__body';
      section.appendChild(body);

      var sibling = section.nextSibling;
      while (sibling) {
        if (sibling.nodeType === 1 && sibling.tagName === 'H3') break;
        if (
          sibling.nodeType === 1 &&
          sibling.classList &&
          sibling.classList.contains('q-pdp-desc-section')
        ) {
          break;
        }
        var next = sibling.nextSibling;
        if (sibling.nodeType === 1 || (sibling.nodeType === 3 && sibling.textContent.trim())) {
          body.appendChild(sibling);
        } else if (sibling.parentNode) {
          sibling.parentNode.removeChild(sibling);
        }
        sibling = next;
      }

      body.querySelectorAll(':scope > p.q-pdp-desc-overview, :scope > p:not(:has(> img))').forEach(function (p) {
        convertMarketingParagraph(p);
      });

      if (body.querySelector('img, video, iframe')) {
        section.classList.add('q-pdp-desc-section--media');
      } else if (body.querySelector('.q-pdp-feature-cards')) {
        section.classList.add('q-pdp-desc-section--features');
      }
    });

    if (description.querySelector('.q-pdp-desc-section--features')) {
      description.querySelectorAll(':scope > p.q-pdp-desc-overview, :scope > p.q-pdp-desc-intro').forEach(function (p) {
        p.remove();
      });
    }

    description.querySelectorAll('.q-pdp-feature-card').forEach(function (card) {
      var titleEl = card.querySelector('.q-pdp-feature-card__title');
      var textEl = card.querySelector('.q-pdp-feature-card__text');
      if (!titleEl || !textEl) return;

      var rawText = cleanMarketingText(textEl.textContent || '');
      if (!rawText) rawText = cleanMarketingText(titleEl.textContent || '');
      if (!rawText) return;

      var bracket = rawText.match(/^[【\[]([^\]]+)[\]】]:?\s*(.*)$/);
      if (bracket) {
        titleEl.textContent = titleCaseLabel(bracket[1].trim());
        var content = resolveFeatureContent('', bracket[2].trim() || rawText);
        textEl.innerHTML = formatFeatureValue(content.body);
        return;
      }

      var parsed = parseLabelBody(rawText);
      var content = parsed
        ? { title: titleCaseLabel(parsed.name), body: parsed.body }
        : resolveFeatureContent(titleEl.textContent || '', rawText);
      titleEl.textContent = content.title;
      textEl.innerHTML = formatFeatureValue(content.body);
    });

    description.dataset.qDescRestructured = '1';
  }

  function getPdpProductTitle() {
    var h1 =
      document.querySelector('.q-pdp__title') ||
      document.querySelector('.q-pdp h1') ||
      document.querySelector('h1');
    return ((h1 && h1.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function isSeoTitleDump(text, productTitle) {
    var t = (text || '').replace(/\s+/g, ' ').trim();
    if (!t || t.length < 24) return false;
    if (/[.!?]["']?\s*$/.test(t) && t.indexOf('|') === -1) return false;
    var title = (productTitle || '').replace(/\s+/g, ' ').trim();
    var lower = t.toLowerCase();
    var titleLower = title.toLowerCase();
    if (titleLower && (lower === titleLower || lower.indexOf(titleLower) === 0)) return true;
    if (t.indexOf('|') !== -1) return true;
    if ((t.match(/\s[-–—]\s/g) || []).length >= 1 && !/[.!?]$/.test(t)) return true;
    return false;
  }

  function parseSeoHighlightChips(text, productTitle) {
    var title = (productTitle || '').replace(/\s+/g, ' ').trim();
    var titleLower = title.toLowerCase();
    var parts = String(text || '')
      .split(/\s*[|•·]\s*|\s+[-–—]\s+/)
      .map(function (p) {
        return p.replace(/\s+/g, ' ').trim();
      })
      .filter(Boolean);

    var chips = [];
    var seen = {};
    function pushChip(part) {
      var clean = String(part || '').replace(/\s+/g, ' ').trim();
      if (!clean || clean.length < 4) return;
      var lower = clean.toLowerCase();
      if (titleLower && (lower === titleLower || lower.indexOf(titleLower) === 0)) return;
      if (titleLower && titleLower.indexOf(lower) !== -1 && lower.length >= 12) return;
      if (/^(for|and|the|with)$/i.test(clean)) return;
      if (seen[lower]) return;
      seen[lower] = 1;
      chips.push(clean);
    }

    parts.forEach(function (part) {
      var lower = part.toLowerCase();
      if (titleLower && (lower === titleLower || lower.indexOf(titleLower) === 0)) return;

      /* Long SEO tails → short phrase + room line */
      if (part.length > 48) {
        var roomRe = /living room|bedroom|kitchen|bathroom|office|hallway|entryway/gi;
        var rooms = part.match(roomRe) || [];
        var uniqueRooms = [];
        var roomSeen = {};
        rooms.forEach(function (r) {
          var key = r.toLowerCase();
          if (roomSeen[key]) return;
          roomSeen[key] = 1;
          uniqueRooms.push(r.replace(/\b\w/g, function (c) { return c.toUpperCase(); }));
        });

        var head = part.split(',')[0].replace(/\s+for\s+.+$/i, '').trim();
        if (head.length >= 4 && head.length <= 56) pushChip(head);
        else if (part.indexOf(',') !== -1) pushChip(part.slice(0, part.indexOf(',')).trim());

        if (uniqueRooms.length) pushChip(uniqueRooms.join(' · '));
        return;
      }

      pushChip(part);
    });
    return chips.slice(0, 4);
  }

  function buildHighlightsSection(chips) {
    var section = document.createElement('section');
    section.className = 'q-pdp-desc-section q-pdp-desc-section--highlights';

    var title = document.createElement('h3');
    title.className = 'q-pdp-desc-section__title';
    title.textContent = 'Highlights';
    section.appendChild(title);

    var body = document.createElement('div');
    body.className = 'q-pdp-desc-section__body';

    if (chips.length === 1) {
      var lead = document.createElement('p');
      lead.className = 'q-pdp-desc-lead';
      lead.textContent = chips[0];
      body.appendChild(lead);
    } else {
      var list = document.createElement('ul');
      list.className = 'q-pdp-desc-tags';
      chips.forEach(function (chip) {
        var li = document.createElement('li');
        li.className = 'q-pdp-desc-tag';
        li.textContent = chip;
        list.appendChild(li);
      });
      body.appendChild(list);
    }
    section.appendChild(body);
    return section;
  }

  function normalizeLeadingSeoDump(description) {
    if (!description || description.dataset.qSeoNormalized === '1') return;
    description.dataset.qSeoNormalized = '1';

    var productTitle = getPdpProductTitle();
    var node = description.firstElementChild;
    while (node) {
      var next = node.nextElementSibling;
      if (node.querySelector && node.querySelector('img, video, iframe, table, .q-pdp-desc-section, .q-pdp-feature-cards, .q-pdp-spec-grid')) {
        break;
      }
      if (node.matches && node.matches('img, video, iframe, table, .q-pdp-desc-section')) break;

      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) {
        if (node.parentNode) node.parentNode.removeChild(node);
        node = next;
        continue;
      }

      if (!/^(DIV|P|SPAN|H1|H2|H3|H4|H5|H6)$/i.test(node.tagName)) break;
      if (!isSeoTitleDump(text, productTitle)) break;

      var chips = parseSeoHighlightChips(text, productTitle);
      if (chips.length) {
        node.replaceWith(buildHighlightsSection(chips));
      } else if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
      break;
    }
  }

  function isImageOnlyNode(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.tagName === 'IMG') return true;
    if (el.matches && el.matches('picture') && el.querySelector('img')) return true;
    if (
      el.tagName === 'P' &&
      el.children.length === 1 &&
      el.querySelector(':scope > img') &&
      !(el.textContent || '').replace(/\s+/g, ' ').trim()
    ) {
      return true;
    }
    return false;
  }

  function isAliExpressMediaDump(el) {
    if (!el || el.nodeType !== 1) return false;
    if (!el.matches) return false;
    if (!el.matches('.detailmodule_html, .detail-desc-decorate-richtext, .detail-desc-decorate')) {
      return false;
    }
    var imgs = el.querySelectorAll('img');
    if (imgs.length < 1) return false;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    /* Dump is media-first: little/no real copy besides images */
    return text.length < 40 || imgs.length >= 2;
  }

  function extractImagesFromNode(el) {
    var out = [];
    if (!el) return out;
    if (el.tagName === 'IMG') {
      out.push(el);
      return out;
    }
    if (el.matches && el.matches('picture')) {
      var picImg = el.querySelector('img');
      if (picImg) out.push(picImg);
      return out;
    }
    if (isImageOnlyNode(el)) {
      var only = el.querySelector('img');
      if (only) out.push(only);
      return out;
    }
    Array.prototype.forEach.call(el.querySelectorAll('img'), function (img) {
      out.push(img);
    });
    return out;
  }

  function buildDescriptionMediaGallery(imgs) {
    var PREVIEW_COUNT = 2;
    var section = document.createElement('section');
    section.className = 'q-pdp-desc-section q-pdp-desc-section--media';

    var title = document.createElement('h3');
    title.className = 'q-pdp-desc-section__title';
    title.textContent = 'Product details';
    section.appendChild(title);

    var body = document.createElement('div');
    body.className = 'q-pdp-desc-section__body';

    var gallery = document.createElement('div');
    gallery.className = 'q-pdp-desc-gallery q-pdp-desc-gallery--stack';

    var valid = [];
    imgs.forEach(function (img) {
      if (img && img.getAttribute('src')) valid.push(img);
    });
    var collapse = valid.length > PREVIEW_COUNT;
    if (collapse) gallery.classList.add('is-collapsed');

    valid.forEach(function (img, idx) {
      var figure = document.createElement('figure');
      figure.className = 'q-pdp-desc-gallery__item';
      if (collapse && idx >= PREVIEW_COUNT) {
        figure.classList.add('q-pdp-desc-gallery__item--more');
        figure.hidden = true;
      }
      img.classList.add('q-pdp-desc-img--zoomable');
      img.setAttribute('loading', img.getAttribute('loading') || 'lazy');
      img.setAttribute('decoding', 'async');
      figure.appendChild(img);
      gallery.appendChild(figure);
    });

    body.appendChild(gallery);

    if (collapse) {
      var extra = valid.length - PREVIEW_COUNT;
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'q-pdp-desc-gallery__more';
      moreBtn.setAttribute('aria-expanded', 'false');
      moreBtn.textContent = 'View more photos (' + extra + ')';
      moreBtn.addEventListener('click', function () {
        var open = gallery.classList.contains('is-collapsed');
        gallery.classList.toggle('is-collapsed', !open);
        gallery.querySelectorAll('.q-pdp-desc-gallery__item--more').forEach(function (fig) {
          fig.hidden = !open;
        });
        moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        moreBtn.textContent = open ? 'Show less' : 'View more photos (' + extra + ')';
      });
      body.appendChild(moreBtn);
    }

    section.appendChild(body);
    return section;
  }

  function normalizeAliExpressMediaDumps(description) {
    if (!description || description.dataset.qMediaDumpNormalized === '1') return;
    description.dataset.qMediaDumpNormalized = '1';

    var kids = Array.prototype.slice.call(description.children);
    kids.forEach(function (el) {
      if (!isAliExpressMediaDump(el)) return;
      var imgs = extractImagesFromNode(el);
      if (!imgs.length) {
        if (el.parentNode) el.parentNode.removeChild(el);
        return;
      }
      var gallery = buildDescriptionMediaGallery(imgs);
      el.replaceWith(gallery);
    });
  }

  function wrapOrphanDescriptionImages(description) {
    if (!description || description.dataset.qMediaWrapped === '1') return;
    description.dataset.qMediaWrapped = '1';

    normalizeAliExpressMediaDumps(description);

    var kids = Array.prototype.slice.call(description.children);
    var run = [];
    function flush(beforeEl) {
      if (!run.length) return;
      var imgs = [];
      run.forEach(function (el) {
        extractImagesFromNode(el).forEach(function (img) {
          imgs.push(img);
        });
      });
      if (!imgs.length) {
        run = [];
        return;
      }
      var gallery = buildDescriptionMediaGallery(imgs);
      description.insertBefore(gallery, beforeEl || null);
      run = [];
    }

    kids.forEach(function (el) {
      if (el.classList && el.classList.contains('q-pdp-desc-section')) {
        flush(el);
        return;
      }
      if (el.tagName === 'IMG' || isImageOnlyNode(el) || isAliExpressMediaDump(el)) {
        run.push(el);
      } else {
        flush(el);
      }
    });
    flush(null);
  }

  function enhancePdpDescription() {
    var description = document.querySelector('.q-pdp__description');
    if (!description || description.dataset.qDescEnhanced === '1') return;

    normalizeLeadingSeoDump(description);

    var hasSpecTable = !!description.querySelector('table, .q-pdp-desc-specs');
    var productTitle = getPdpProductTitle();

    description.querySelectorAll(':scope > p, :scope > div').forEach(function (p) {
      if (p.classList.contains('q-pdp-desc-section')) return;
      if (p.querySelector('img, video, iframe, table, ul, ol')) return;
      if (p.classList.contains('q-pdp-desc-intro')) return;
      if (p.classList.contains('q-pdp-desc-section--highlights')) return;

      var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      if (isSeoTitleDump(text, productTitle)) {
        var chips = parseSeoHighlightChips(text, productTitle);
        if (chips.length) p.replaceWith(buildHighlightsSection(chips));
        else p.remove();
        return;
      }

      if (p.tagName === 'P' && convertMarketingParagraph(p)) return;

      var colonCount = (text.match(/:/g) || []).length;
      var rows = parseInlineSpecPairs(text);
      if (rows) {
        var grid = buildSpecGrid(rows);
        var heading = document.createElement('h3');
        heading.textContent = 'Overview';
        p.replaceWith(heading, grid);
        return;
      }

      if (colonCount >= 4 && hasSpecTable) {
        p.remove();
        return;
      }

      if (colonCount >= 3 && description.querySelector('h3, .q-pdp-feature-cards')) {
        p.remove();
        return;
      }

      if (colonCount >= 3) {
        p.classList.add('q-pdp-desc-overview');
        return;
      }

      if (p.tagName === 'P' && text.length > 40 && !/[.!?]$/.test(text)) {
        p.classList.add('q-pdp-desc-intro');
      }
    });

    description.dataset.qDescEnhanced = '1';
  }

  window.qEnhancePdpDescription = enhancePdpDescription;

  function releaseDescriptionClampForPhotoGallery() {
    /* Photo gallery has its own "View more photos" — hide duplicate "View full description". */
    if (!document.querySelector('.q-pdp-desc-gallery__more')) return;
    var desc = document.querySelector('.q-pdp__description');
    var wrap = document.querySelector('[data-q-desc-more-wrap]');
    if (desc) {
      desc.classList.remove('is-clamped', 'has-more');
      desc.style.maxHeight = '';
    }
    if (wrap) {
      wrap.hidden = true;
      wrap.setAttribute('data-q-gallery-owns-more', '1');
    }
  }

  function runPdpDescriptionEnhancements() {
    collapseEmptyDescriptionBlocks();
    enhancePdpDescription();
    restructurePdpDescription();
    var description = document.querySelector('.q-pdp__description');
    if (description) wrapOrphanDescriptionImages(description);
    releaseDescriptionClampForPhotoGallery();
    if (typeof window.qBindPdpDescriptionZoom === 'function') {
      window.qBindPdpDescriptionZoom();
    }
  }

  window.qCollapseEmptyDescriptionBlocks = collapseEmptyDescriptionBlocks;

  window.qSyncReviewsSectionVisibility = syncReviewsSectionVisibility;

  /* Keep EZ Amazon Reviews widget inside the reviews host (avoid split layout) */
  function pinEzReviewsBeforeDescription() {
    styleEzReviewUi();
    var description = document.querySelector('.q-pdp__description');
    if (!description) return;

    var host =
      document.querySelector('.q-pdp-reviews__inner') ||
      document.getElementById('aliexpress-review-wrapper-sp');
    if (!host) return;

    var widget =
      document.querySelector('.ez-amrv-wrapp') ||
      document.getElementById('ra-dt-wrpp');
    if (widget && !host.contains(widget)) {
      host.appendChild(widget);
    }

    var reviewsSection = document.querySelector('.q-pdp-reviews');
    if (reviewsSection && description.compareDocumentPosition(reviewsSection) & Node.DOCUMENT_POSITION_FOLLOWING) {
      description.parentNode.insertBefore(reviewsSection, description);
    }
  }

  function watchEzReviewPlacement() {
    pinEzReviewsBeforeDescription();
    if (!document.querySelector('.q-pdp')) return;

    var observer = new MutationObserver(function () {
      pinEzReviewsBeforeDescription();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    var attempts = 0;
    var timer = setInterval(function () {
      pinEzReviewsBeforeDescription();
      attempts += 1;
      if (attempts >= 20) clearInterval(timer);
    }, 500);
  }

  window.addEventListener('load', watchEzReviewPlacement);
  document.addEventListener('DOMContentLoaded', watchEzReviewPlacement);

  /* Wishlist — localStorage + #wishlist panel on homepage */
  var WISHLIST_KEY = 'q_wishlist_v1';
  var wishlistPanel = document.querySelector('[data-q-wishlist-panel]');
  var wishlistGrid = document.querySelector('[data-q-wishlist-grid]');
  var wishlistEmpty = document.querySelector('[data-q-wishlist-empty]');
  var wishlistCount = document.querySelector('[data-q-wishlist-count]');
  var homeSection = document.querySelector('.q-home');

  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function productFromWishButton(btn) {
    return {
      id: String(btn.dataset.productId || ''),
      handle: btn.dataset.productHandle || '',
      title: btn.dataset.productTitle || '',
      url: btn.dataset.productUrl || '',
      image: btn.dataset.productImage || '',
      price: btn.dataset.productPrice || ''
    };
  }

  function syncWishButtons() {
    var ids = readWishlist().map(function (p) {
      return String(p.id);
    });
    document.querySelectorAll('[data-q-wish]').forEach(function (btn) {
      var saved = ids.indexOf(String(btn.dataset.productId || '')) >= 0;
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }

  function renderWishlist() {
    if (!wishlistGrid || !wishlistEmpty) return;
    var list = readWishlist();
    wishlistGrid.innerHTML = '';

    if (list.length === 0) {
      wishlistEmpty.hidden = false;
      if (wishlistCount) wishlistCount.hidden = true;
      return;
    }

    wishlistEmpty.hidden = true;
    if (wishlistCount) {
      wishlistCount.hidden = false;
      wishlistCount.textContent = list.length + (list.length === 1 ? ' item' : ' items');
    }

    list.forEach(function (item) {
      var card = document.createElement('article');
      card.className = 'q-card';
      card.setAttribute('role', 'listitem');
      var imgHtml = item.image
        ? '<img class="q-card__img" src="' + item.image + '" alt="" loading="lazy">'
        : '<div class="q-card__img q-card__img--placeholder"></div>';
      card.innerHTML =
        '<a href="' +
        item.url +
        '" class="q-card__media">' +
        imgHtml +
        '<button type="button" class="q-card__wish is-saved" aria-label="Remove from wishlist" aria-pressed="true" data-q-wish data-product-id="' +
        item.id +
        '" data-product-handle="' +
        (item.handle || '') +
        '" data-product-title="' +
        (item.title || '').replace(/"/g, '&quot;') +
        '" data-product-url="' +
        (item.url || '') +
        '" data-product-image="' +
        (item.image || '') +
        '" data-product-price="' +
        (item.price || '') +
        '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg></button></a>' +
        '<div class="q-card__info"><div class="q-card__row"><h3 class="q-card__title"><a href="' +
        item.url +
        '">' +
        item.title +
        '</a></h3><div class="q-card__price"><span>' +
        item.price +
        '</span></div></div></div>';
      wishlistGrid.appendChild(card);
    });
  }

  function toggleWishlistItem(product) {
    if (!product.id) return;
    var list = readWishlist();
    var idx = list.findIndex(function (p) {
      return String(p.id) === String(product.id);
    });
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push(product);
    }
    writeWishlist(list);
    syncWishButtons();
    if (window.location.hash === '#wishlist') renderWishlist();
  }

  function syncWishlistRoute() {
    if (!wishlistPanel) return;
    var show = window.location.hash === '#wishlist';
    wishlistPanel.hidden = !show;
    if (homeSection) homeSection.hidden = show;
    if (show) {
      renderWishlist();
      wishlistPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-q-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleWishlistItem(productFromWishButton(btn));
  });

  window.addEventListener('hashchange', syncWishlistRoute);
  syncWishButtons();
  syncWishlistRoute();
  window.qSyncWishButtons = syncWishButtons;

  /* Recent orders marquee — product page top-left */
  function mountRecentOrdersOnGallery(root) {
    if (!root) return;
    var host =
      document.querySelector('[data-q-recent-orders-slot]') ||
      document.querySelector('.u-pdp__gallery') ||
      document.querySelector('.q-pdp__gallery') ||
      document.querySelector('.u-pdp__stage') ||
      document.querySelector('.q-pdp__stage');
    if (!host) return;
    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }
    if (root.parentElement !== host) host.appendChild(root);
  }

  function bindRecentOrdersScrollHide(root) {
    /* Inline/absolute placements scroll away naturally — no viewport sticky hide needed. */
    if (root && root.closest('[data-q-recent-orders-slot], .u-pdp__stage, .q-pdp__stage, .u-pdp__gallery, .q-pdp__gallery')) {
      root.classList.remove('q-recent-orders--hidden');
      return;
    }

    var gallery =
      document.querySelector('.u-pdp__gallery') || document.querySelector('.q-pdp__gallery');
    if (!root || !gallery) return;

    function update() {
      var galleryBottom = gallery.getBoundingClientRect().bottom + window.scrollY - 72;
      if (window.scrollY > galleryBottom) {
        root.classList.add('q-recent-orders--hidden');
      } else {
        root.classList.remove('q-recent-orders--hidden');
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function ensureRecentOrdersRoot() {
    var existing = document.querySelector('[data-q-recent-orders]');
    if (existing) {
      mountRecentOrdersOnGallery(existing);
      return existing;
    }
    if (!document.body.classList.contains('q-template-product')) return null;

    var feedUrl = '';
    var assetEl =
      document.querySelector('script[src*="quince.pdp.js"]') ||
      document.querySelector('link[href*="quince.css"]');
    var assetSrc = assetEl && (assetEl.src || assetEl.href);
    if (assetSrc) {
      feedUrl = String(assetSrc)
        .replace(/quince\.pdp\.js.*$/i, 'recent-orders-feed.json')
        .replace(/quince\.js.*$/i, 'recent-orders-feed.json')
        .replace(/quince\.css.*$/i, 'recent-orders-feed.json');
    }
    if (!feedUrl || feedUrl.indexOf('recent-orders-feed.json') < 0) {
      feedUrl = '/cdn/shop/t/31/assets/recent-orders-feed.json';
    }

    var handle = '';
    var path = (location.pathname || '').split('/products/')[1] || '';
    if (path) handle = decodeURIComponent(path.split(/[?#]/)[0]);

    var root = document.createElement('div');
    root.className = 'q-recent-orders q-recent-orders--pending';
    root.setAttribute('data-q-recent-orders', '');
    root.setAttribute('role', 'region');
    root.setAttribute('aria-label', 'Recent orders');
    root.setAttribute('aria-live', 'off');
    root.setAttribute('data-feed-url', feedUrl);
    if (handle) root.setAttribute('data-product-handle', handle);
    root.hidden = true;
    root.innerHTML =
      '<div class="q-recent-orders__viewport">' +
      '<div class="q-recent-orders__track" data-q-recent-track></div>' +
      '</div>';
    var host =
      document.querySelector('[data-q-recent-orders-slot]') ||
      document.querySelector('.u-pdp__gallery') ||
      document.querySelector('.q-pdp__gallery') ||
      document.querySelector('.u-pdp__stage') ||
      document.querySelector('.q-pdp__stage');
    if (host) {
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(root);
    } else document.body.appendChild(root);
    return root;
  }

  function initRecentOrdersMarquee() {
    var root = ensureRecentOrdersRoot();
    if (!root) return;

    var feedUrl = root.getAttribute('data-feed-url');
    var productHandle = root.getAttribute('data-product-handle') || '';
    var isProductPage = document.body.classList.contains('q-template-product');
    if (!isProductPage) return;

    bindRecentOrdersScrollHide(root);

    var track = root.querySelector('[data-q-recent-track]');
    if (!track) return;

    function resolveCreatedAt(item) {
      if (item.seconds_ago != null && item.seconds_ago !== '') {
        return new Date(Date.now() - Number(item.seconds_ago) * 1000).toISOString();
      }
      return item.created_at || '';
    }

    function normalizeFeed(feed) {
      if (!Array.isArray(feed)) return [];
      return feed.map(function (item) {
        var copy = Object.assign({}, item);
        copy.created_at = resolveCreatedAt(copy);
        return copy;
      });
    }

    function formatTimeAgo(iso) {
      if (!iso) return '';
      var diff = Date.now() - new Date(iso).getTime();
      if (diff < 0) diff = 0;
      var secs = Math.floor(diff / 1000);
      if (secs < 60) return secs + ' sec ago';
      var mins = Math.floor(secs / 60);
      if (mins === 1) return '1 min ago';
      if (mins < 60) return mins + ' min ago';
      var hrs = Math.floor(mins / 60);
      if (hrs === 1) return '1 hr ago';
      if (hrs < 24) return hrs + ' hr ago';
      var days = Math.floor(hrs / 24);
      return days === 1 ? '1 day ago' : days + ' days ago';
    }

    function syncItemTimestamp(node) {
      var secondsAgo = node.getAttribute('data-seconds-ago');
      if (secondsAgo != null && secondsAgo !== '') {
        node.setAttribute('data-created-at', resolveCreatedAt({ seconds_ago: secondsAgo }));
      }
    }

    function updateTimes() {
      root.querySelectorAll('[data-q-recent-item]').forEach(function (node) {
        syncItemTimestamp(node);
        var timeEl = node.querySelector('[data-q-recent-time]');
        if (timeEl) {
          timeEl.textContent = formatTimeAgo(node.getAttribute('data-created-at'));
        }
      });
    }

    function buildItem(item) {
      var createdAt = resolveCreatedAt(item);
      var el = document.createElement('div');
      el.className = 'q-recent-orders__item';
      el.setAttribute('data-q-recent-item', '');
      el.setAttribute('data-created-at', createdAt);
      if (item.seconds_ago != null && item.seconds_ago !== '') {
        el.setAttribute('data-seconds-ago', String(item.seconds_ago));
      }

      var location = '';
      if (item.city) {
        location = ' in ' + item.city;
        if (item.state) location += ', ' + item.state;
      }
      var action =
        productHandle && item.product_handle === productHandle ? ' bought this' : ' placed an order';
      var softName = String(item.name || '')
        .replace(/\s+[A-Za-z]\.?\s*$/, '')
        .trim()
        .split(/\s+/)[0];
      softName = softName.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ'\-]/g, '');
      if (!softName || softName.length < 2) softName = 'A shopper';
      else softName = softName.charAt(0).toUpperCase() + softName.slice(1);

      el.innerHTML =
        '<span class="q-recent-orders__dot" aria-hidden="true"></span>' +
        '<div class="q-recent-orders__content">' +
        '<span class="q-recent-orders__text"><strong>' +
        softName +
        '</strong>' +
        location +
        action +
        '</span>' +
        '<span class="q-recent-orders__time" data-q-recent-time></span>' +
        '</div>';

      var timeEl = el.querySelector('[data-q-recent-time]');
      if (timeEl) timeEl.textContent = formatTimeAgo(createdAt);
      return el;
    }

    function pickItems(feed) {
      if (!isProductPage || !productHandle) return feed.slice(0, 18);
      var matched = feed.filter(function (item) {
        return item.product_handle && item.product_handle === productHandle;
      });
      var others = feed.filter(function (item) {
        return !(item.product_handle && item.product_handle === productHandle);
      });
      return matched.concat(others).slice(0, 18);
    }

    function startRecentOrdersTicker() {
      var viewport = root.querySelector('.q-recent-orders__viewport');
      if (!viewport) return;

      var pauseMs = 4000;
      var transitionMs = 450;
      var index = 0;
      var offsets = [];
      var viewportHeight = 0;
      var tickerId = null;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function getItems() {
        return track.querySelectorAll('[data-q-recent-item]');
      }

      function measure() {
        var items = getItems();
        if (!items.length) return 0;

        offsets = [];
        viewportHeight = 0;
        var total = 0;

        items.forEach(function (el, i) {
          offsets[i] = total;
          var h = el.offsetHeight;
          viewportHeight = Math.max(viewportHeight, h);
          total += h;
        });

        viewport.style.height = viewportHeight + 'px';
        return items.length;
      }

      function setPosition(nextIndex, animate) {
        var y = offsets[nextIndex] || 0;
        track.style.transition = animate ? 'transform ' + transitionMs / 1000 + 's ease' : 'none';
        track.style.transform = 'translateY(-' + y + 'px)';
      }

      function prepareLoopClone() {
        var items = getItems();
        if (!items.length) return;
        track.querySelectorAll('[data-q-recent-clone]').forEach(function (node) {
          node.remove();
        });
        if (items.length === 1) return;
        var clone = items[0].cloneNode(true);
        clone.setAttribute('data-q-recent-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      function tick() {
        var items = getItems();
        if (items.length <= 1) return;

        if (index >= items.length - 1) {
          index = 0;
          setPosition(0, false);
          return;
        }

        index += 1;
        setPosition(index, true);
      }

      function start() {
        if (tickerId) {
          clearInterval(tickerId);
          tickerId = null;
        }

        index = 0;
        track.style.transform = 'translateY(0)';
        track.style.transition = 'none';

        var count = measure();
        if (!count) return;

        prepareLoopClone();
        measure();
        setPosition(0, false);

        if (count === 1 || reducedMotion) return;

        tickerId = setInterval(tick, pauseMs);
      }

      start();
      window.addEventListener('resize', function () {
        measure();
        setPosition(index, false);
      });
    }

    function renderFeed(feed) {
      feed = normalizeFeed(feed);
      if (!Array.isArray(feed) || feed.length === 0) return false;

      var items = pickItems(feed);
      if (!items.length) return false;

      track.innerHTML = '';
      items.forEach(function (item) {
        track.appendChild(buildItem(item));
      });

      root.hidden = false;
      root.classList.remove('q-recent-orders--pending');
      updateTimes();
      setInterval(updateTimes, 60000);
      startRecentOrdersTicker();
      return true;
    }

    /* Server-rendered from shop metafield */
    if (track.querySelector('[data-q-recent-item]')) {
      root.hidden = false;
      root.classList.remove('q-recent-orders--pending');
      updateTimes();
      setInterval(updateTimes, 60000);
      startRecentOrdersTicker();
      return;
    }

    if (!feedUrl) return;

    fetch(feedUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('feed load failed');
        return res.json();
      })
      .then(function (feed) {
        if (!renderFeed(feed)) {
          root.hidden = true;
        }
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  initRecentOrdersMarquee();

  /* PDP header: transparent over the gallery until the announcement bar scrolls away */
  function initPdpHeaderScroll() {
    if (!document.body.classList.contains('q-template-product')) return;
    if (!document.querySelector('.q-pdp__stage')) return;
    var header = document.querySelector('.q-header');
    if (!header || !('IntersectionObserver' in window)) return;
    var host = header.closest('.shopify-section') || header;
    var sentinel = document.createElement('div');
    sentinel.className = 'q-header__top-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    host.parentNode.insertBefore(sentinel, host);
    new IntersectionObserver(function (entries) {
      var atTop = entries[entries.length - 1].isIntersecting;
      header.classList.toggle('is-scrolled', !atTop);
    }).observe(sentinel);
  }

  initPdpHeaderScroll();

  /* Cart page — Quince shopping bag */
  function initCartPage() {
    var cartRoot = document.querySelector('[data-q-cart]');
    if (!cartRoot) return;

    var moneyFormat = cartRoot.getAttribute('data-money-format') || '${{amount}}';
    var sitewidePct = parseFloat(cartRoot.getAttribute('data-auto-discount-pct') || '0') || 0;

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function applySitewide(cents) {
      var amount = Number(cents) || 0;
      if (!(sitewidePct > 0) || !(amount > 0)) return amount;
      return amount - Math.floor((amount * sitewidePct) / 100);
    }

    function updateHeaderCartCount(count) {
      document.querySelectorAll('.q-header__cart-count, .q-drawer__cart-count').forEach(function (el) {
        if (count > 0) {
          el.textContent = count;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
    }

    function setQtyDownIcon(btn, qty) {
      if (!btn) return;
      if (qty <= 1) {
        btn.innerHTML =
          '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" aria-hidden="true"><path d="m4.413 6.258.989 10.003a.3.3 0 0 0 .299.27h8.598a.3.3 0 0 0 .299-.27l.989-10.003M2.564 6.016h14.872M7.179 6.016 7.7 3.828a.23.23 0 0 1 .226-.178h4.148c.107 0 .2.074.226.178l.521 2.188"/></svg>';
        btn.setAttribute('aria-label', 'Remove item');
      } else {
        btn.innerHTML =
          '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-linecap="square" aria-hidden="true"><path d="M4.5 10h11"/></svg>';
        btn.setAttribute('aria-label', 'Decrease quantity');
      }
    }

    function retailStrikeCents(displayCents, retailPct) {
      var display = Number(displayCents) || 0;
      var pct = parseInt(retailPct, 10) || 0;
      if (!(pct > 0) || !(display > 0) || pct >= 100) return 0;
      var strikeRaw = Math.floor((display * 100) / (100 - pct));
      var strike = Math.round(strikeRaw / 100) * 100;
      if (strike <= display) strike = strikeRaw;
      return strike > display ? strike : 0;
    }

    function updateLinePrices(line, item) {
      var compareEls = line.querySelectorAll('[data-q-cart-line-compare]');
      var priceEls = line.querySelectorAll('[data-q-cart-line-price]');
      // Main = Shopify final (± sitewide). Strike = same traditional-retail formula as PDP.
      var shopUnit = Number(item.final_price) || 0;
      var displayUnit = applySitewide(shopUnit);
      var displayLine = displayUnit * (item.quantity || 1);
      var retailPct = parseInt(line.getAttribute('data-retail-pct') || '0', 10) || 0;
      var strikeUnit = retailStrikeCents(displayUnit, retailPct);
      var compareLine = 0;
      var showCompare = false;

      if (strikeUnit > displayUnit) {
        compareLine = strikeUnit * (item.quantity || 1);
        showCompare = true;
      } else if (item.original_line_price > item.final_line_price) {
        compareLine = item.original_line_price;
        showCompare = true;
        strikeUnit = Number(item.original_price) || 0;
      }

      compareEls.forEach(function (compareEl) {
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.textContent = formatMoney(compareLine);
      });
      priceEls.forEach(function (priceEl) {
        priceEl.textContent = formatMoney(displayLine);
      });
      line.setAttribute('data-list-unit', String(shopUnit));
      line.setAttribute('data-unit-cents', String(displayUnit));
      line.setAttribute('data-compare-unit', String(strikeUnit || 0));
    }

    function findCartLine(itemKey, variantId) {
      var lines = cartRoot.querySelectorAll('.q-cart__item[data-line-key]');
      var keyStr = itemKey != null ? String(itemKey) : '';
      var i;
      for (i = 0; i < lines.length; i++) {
        if (lines[i].getAttribute('data-line-key') === keyStr) return lines[i];
      }
      if (variantId != null) {
        var variantStr = String(variantId);
        for (i = 0; i < lines.length; i++) {
          if (lines[i].getAttribute('data-variant-id') === variantStr) return lines[i];
        }
      }
      return null;
    }

    function cartSubtotal(cart) {
      if (!Array.isArray(cart.items)) return 0;
      return cart.items.reduce(function (sum, item) {
        var listUnit = Number(item.final_price) || 0;
        return sum + applySitewide(listUnit) * (item.quantity || 1);
      }, 0);
    }

    function applyCartResponse(cart) {
      if (!cart || !Array.isArray(cart.items)) {
        window.location.reload();
        return;
      }

      var displaySub = cartSubtotal(cart);
      var subtotalEls = cartRoot.querySelectorAll('[data-q-cart-subtotal]');
      var subtotalEl = subtotalEls[0];
      subtotalEls.forEach(function (el) {
        el.textContent = formatMoney(displaySub);
      });

      var totalRow = cartRoot.querySelector('[data-q-cart-total-row]');
      var totalEl = cartRoot.querySelector('[data-q-cart-total]');
      var hasCartDiscount =
        cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0;

      if (totalRow) totalRow.hidden = false;
      if (totalEl) totalEl.textContent = formatMoney(displaySub);

      cartRoot.querySelectorAll('[data-q-cart-discount]').forEach(function (row) {
        row.remove();
      });
      if (hasCartDiscount && subtotalEl) {
        var summary = subtotalEl.closest('.q-cart__summary');
        var shippingRow = cartRoot.querySelector('.q-cart__shipping-free');
        var anchor = totalRow || (shippingRow && shippingRow.closest('.q-cart__summary-row'));
        cart.cart_level_discount_applications.forEach(function (discount) {
          var amount = discount.total_allocated_amount || 0;
          var row = document.createElement('div');
          row.className = 'q-cart__summary-row q-cart__summary-row--discount';
          row.setAttribute('data-q-cart-discount', '');
          row.innerHTML =
            '<span>' +
            (discount.title || 'Discount') +
            '</span><span>-' +
            formatMoney(amount) +
            '</span>';
          if (summary && anchor) summary.insertBefore(row, anchor);
        });
      }

      updateHeaderCartCount(cart.item_count);

      var keys = Object.create(null);
      cart.items.forEach(function (item) {
        if (item.key == null) return;
        keys[String(item.key)] = item;
      });

      cart.items.forEach(function (item) {
        var line = findCartLine(item.key, item.variant_id || item.id);
        if (!line) return;
        var qtyVal = line.querySelector('[data-q-cart-qty-value]');
        var qtyWrap = line.querySelector('[data-q-cart-qty]');
        var downBtn = line.querySelector('[data-q-cart-qty-down]');
        if (item.key != null) line.setAttribute('data-line-key', String(item.key));
        if (qtyVal) qtyVal.textContent = item.quantity;
        updateLinePrices(line, item);
        if (qtyWrap) qtyWrap.setAttribute('data-qty', item.quantity);
        setQtyDownIcon(downBtn, item.quantity);
      });

      cartRoot.querySelectorAll('.q-cart__item[data-line-key]').forEach(function (lineEl) {
        var lineKey = lineEl.getAttribute('data-line-key');
        if (!lineKey || !keys[lineKey]) lineEl.remove();
      });

      if (cart.item_count === 0) {
        window.location.reload();
      }
    }

    function changeLine(key, quantity) {
      if (!key) return Promise.reject(new Error('missing line key'));
      return qShopifyFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: String(key), quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart change failed');
          return res.json();
        })
        .then(applyCartResponse)
        .catch(function () {
          window.location.reload();
        });
    }

    var REC_ADD_ICON =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 9.5h17l-1.6 9.6a1.5 1.5 0 0 1-1.5 1.25H6.6a1.5 1.5 0 0 1-1.5-1.25L3.5 9.5z"/><path d="M8 9.5 10.5 4M16 9.5 13.5 4"/><path d="M12 12.25v5.5M9.25 15h5.5"/></svg>';

    function escHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function recCardHtml(product) {
      var variants = product.variants || [];
      var variant = variants.filter(function (v) { return v.available; })[0] || variants[0] || {};
      var single = variants.length === 1 && /^default title$/i.test(String(variant.title || ''));
      var price = applySitewide(product.price_min != null ? product.price_min : product.price);
      var img = product.featured_image || '';
      if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=400';
      var title = escHtml(product.title);
      var url = escHtml(product.url);
      var add =
        single && variant.available
          ? '<button type="button" class="q-cart-recs__add" data-q-cart-rec-add data-variant-id="' +
            variant.id +
            '" data-variant-price="' +
            applySitewide(variant.price) +
            '" data-product-title="' +
            title +
            '" aria-label="Add ' +
            title +
            ' to bag">' +
            REC_ADD_ICON +
            '</button>'
          : '<a href="' + url + '" class="q-cart-recs__add" aria-label="Choose options for ' + title + '">' + REC_ADD_ICON + '</a>';
      return (
        '<div class="q-cart-recs__card"><div class="q-cart-recs__media"><a href="' +
        url +
        '" class="q-cart-recs__img-link" aria-label="' +
        title +
        '">' +
        (img ? '<img class="q-cart-recs__img" src="' + escHtml(img) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        add +
        '</div><div class="q-cart-recs__price">' +
        formatMoney(price) +
        '</div></div>'
      );
    }

    var recsRoot = cartRoot.querySelector('[data-q-cart-recs]');
    if (recsRoot) {
      var recsGrid = recsRoot.querySelector('[data-q-cart-recs-panel="recommended"]');
      var cheapGrid = recsRoot.querySelector('[data-q-cart-recs-panel="under90"]');
      var seedId =
        recsRoot.getAttribute('data-seed-product-id') ||
        (cartRoot.querySelector('.q-cart__item[data-product-id]') &&
          cartRoot.querySelector('.q-cart__item[data-product-id]').getAttribute('data-product-id'));
      // Prefer Shopify related/similar products for the first cart item (same category / lookalikes).
      if (recsGrid && seedId) {
        var inCart = {};
        cartRoot.querySelectorAll('.q-cart__item[data-product-id]').forEach(function (lineEl) {
          inCart[lineEl.getAttribute('data-product-id')] = true;
        });
        var recsLimit = parseInt(recsRoot.getAttribute('data-recs-limit'), 10) || 6;
        fetch(
          '/recommendations/products.json?intent=related&limit=' +
            (recsLimit + 8) +
            '&product_id=' +
            encodeURIComponent(seedId),
          { credentials: 'same-origin' }
        )
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (data) {
            var available = ((data && data.products) || []).filter(function (p) {
              return p.available && !inCart[String(p.id)];
            });
            var items = available.slice(0, recsLimit);
            if (items.length >= 3) {
              recsGrid.innerHTML = items.map(recCardHtml).join('');
            }
            if (cheapGrid) {
              var cheap = available
                .filter(function (p) {
                  var cents = applySitewide(p.price_min != null ? p.price_min : p.price);
                  return cents > 0 && cents <= 9000;
                })
                .slice(0, recsLimit);
              if (cheap.length >= 1) {
                cheapGrid.innerHTML = cheap.map(recCardHtml).join('');
                var cheapTab = recsRoot.querySelector('[data-q-cart-recs-tab="under90"]');
                if (!cheapTab) {
                  var tabs = recsRoot.querySelector('.q-cart-recs__tabs');
                  if (tabs) {
                    cheapTab = document.createElement('button');
                    cheapTab.type = 'button';
                    cheapTab.className = 'q-cart-recs__tab';
                    cheapTab.setAttribute('role', 'tab');
                    cheapTab.setAttribute('aria-selected', 'false');
                    cheapTab.setAttribute('data-q-cart-recs-tab', 'under90');
                    cheapTab.textContent = 'UNDER $90 PICKS';
                    tabs.appendChild(cheapTab);
                  }
                }
              }
            }
          })
          .catch(function () {});
      }

      recsRoot.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-q-cart-recs-tab]');
        if (tab) {
          e.preventDefault();
          var name = tab.getAttribute('data-q-cart-recs-tab');
          recsRoot.querySelectorAll('[data-q-cart-recs-tab]').forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          recsRoot.querySelectorAll('[data-q-cart-recs-panel]').forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-q-cart-recs-panel') !== name;
          });
          return;
        }

        var addBtn = e.target.closest('[data-q-cart-rec-add]');
        if (!addBtn || addBtn.disabled) return;
        e.preventDefault();
        var variantId = parseInt(addBtn.getAttribute('data-variant-id'), 10);
        if (!variantId) return;
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
        qShopifyFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart add failed');
            qTrackMetaAddToCart(
              { id: variantId, price: parseInt(addBtn.getAttribute('data-variant-price'), 10) || 0 },
              addBtn.getAttribute('data-product-title') || '',
              1
            );
            window.location.reload();
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.classList.remove('is-loading');
          });
      });
    }

    cartRoot.addEventListener('click', function (e) {
      var upBtn = e.target.closest('[data-q-cart-qty-up]');
      var downBtn = e.target.closest('[data-q-cart-qty-down]');
      var saveBtn = e.target.closest('[data-q-cart-save]');
      var line = e.target.closest('.q-cart__item');
      if (!line) return;

      var key = line.getAttribute('data-line-key');
      var qtyWrap = line.querySelector('[data-q-cart-qty]');
      var qty = parseInt(qtyWrap && qtyWrap.getAttribute('data-qty'), 10) || 1;

      if (upBtn) {
        e.preventDefault();
        changeLine(key, qty + 1);
        return;
      }

      if (downBtn) {
        e.preventDefault();
        changeLine(key, Math.max(0, qty - 1));
        return;
      }

      if (saveBtn) {
        e.preventDefault();
        e.stopPropagation();
        /* Wishlist only — do NOT remove from bag (was killing checkout conversion). */
        toggleWishlistItem({
          id: line.getAttribute('data-product-id') || '',
          handle: line.getAttribute('data-product-handle') || '',
          title: line.getAttribute('data-product-title') || '',
          url: line.getAttribute('data-product-url') || '',
          image: line.getAttribute('data-product-image') || '',
          price: line.getAttribute('data-product-price') || ''
        });
        saveBtn.textContent = 'Saved ✓';
        saveBtn.disabled = true;
        return;
      }
    });

    /* Sync fbp/fbc onto cart before checkout so CAPI can match — never block navigation. */
    var cartForm = cartRoot.querySelector('form.q-cart__form');
    if (cartForm) {
      cartForm.addEventListener('submit', function (e) {
        if (cartForm.getAttribute('data-q-checkout-leaving') === '1') return;
        e.preventDefault();
        e.stopPropagation();
        var submitBtn = cartForm.querySelector('[name="checkout"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Redirecting…';
        }
        cartForm.setAttribute('data-q-checkout-leaving', '1');

        /* Fire IC for full cart (CE checkout_started may also fire with different eventID). */
        qTrackMetaInitiateCheckoutFromDom(cartRoot);

        qSyncMetaCartAttributes()
          .catch(function () {
            return null;
          })
          .then(function () {
            qGoToShopifyCheckout(cartForm);
          });

        /* Absolute failsafe: if sync+submit stalls, hard navigate. */
        window.setTimeout(function () {
          if (window.location.pathname.indexOf('/check') === -1) {
            window.location.href = '/checkout';
          }
        }, 3500);
      });
    }
  }

  initCartPage();

  /* Related / More: Shopify similarity algorithm (PDP only loads quince.pdp.js, not quince.js) */
  function qRelatedCatMatcher(cat) {
    if (cat === 'related-wigs') return /wig|hair|braid|lace|bun|frontal|crochet|weave|ponytail/i;
    if (cat === 'related-costume') return /cosplay|costume|fursuit|kemono|mask|jumpsuit|rhinestone|halloween|anime|katana|ring/i;
    if (cat === 'related-gadgets') return /watch|battery|tv|box|vseebox|streaming|gps|amoled|lifepo|speaker|earbud|headphone|android/i;
    if (cat === 'related-outdoor') return /gazebo|tent|canopy|outdoor|camping|bbq|patio|garden|atv|trailer/i;
    if (cat === 'related-home') return /rug|carpet|bean|sofa|curtain|pillow|furniture|cabinet|mirror|decor|blanket|bedding|lamp|vase|kitchen|storage/i;
    return null;
  }

  function qFilterRelatedCards(root) {
    var cat = root.getAttribute('data-related-cat') || '';
    var re = qRelatedCatMatcher(cat);
    if (!re) return;
    root.querySelectorAll('.q-card, .q-plp__grid > *').forEach(function (card) {
      if (!card || !card.querySelector) return;
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return;
      var hay = (a.getAttribute('href') || '') + ' ' + (a.getAttribute('aria-label') || '') + ' ' + (card.textContent || '');
      if (!re.test(hay)) card.remove();
    });
  }

  function qLoadRelatedSection(root, pickSelector) {
    if (!root) return;
    var url = root.getAttribute('data-url');
    if (!url) return;
    var min = parseInt(root.getAttribute('data-related-min'), 10) || 3;
    var existing = root.querySelectorAll('.q-card').length;
    var backup = root.innerHTML;
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector(pickSelector);
        if (!next) return;
        root.innerHTML = next.innerHTML;
        qFilterRelatedCards(root);
        var n = root.querySelectorAll('.q-card').length;
        if (n >= min || (existing === 0 && n > 0)) {
          root.hidden = false;
        } else if (existing > 0) {
          /* algo too noisy / empty after filter — keep SSR category pool */
          root.innerHTML = backup;
          root.hidden = false;
        } else {
          root.hidden = true;
        }
      })
      .catch(function () {});
  }

  function qInitRelatedBlocks() {
    qLoadRelatedSection(document.querySelector('[data-q-related]'), '[data-q-related]');
    qLoadRelatedSection(document.querySelector('[data-q-related-more]'), '[data-q-related-more]');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', qInitRelatedBlocks);
  } else {
    qInitRelatedBlocks();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('q-card__atc-form')) return;
    event.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var submitBtn = form.querySelector('[type="submit"]');
    if (!idInput) return;
    var variantId = parseInt(idInput.value, 10);
    if (!variantId) return;
    if (submitBtn) submitBtn.disabled = true;

    qShopifyFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (item) {
        var variant = {
          id: variantId,
          price: item && item.price != null ? item.price : 0
        };
        var card = form.closest('[data-product-id]');
        var title = card ? card.getAttribute('data-product-title') : '';
        qTrackMetaAddToCart(variant, title);
        return qSyncMetaCartAttributes().then(function () {
          window.location.href = '/cart';
        });
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        form.submit();
      });
  });
})();

/* ro-ensure-bust 1784109885.872191 */
